/**
 * Scan-Seite der Lageretiketten (Aufgabe #59, 16.10.2026).
 *
 * Ein gescannter Code ist eins von dreien:
 *   - unser Etikett-Link  https://…/pages/scan?s=<SKU>  (QR)
 *   - unsere SKU          (Code128 auf unserem Etikett, oder getippt)
 *   - eine fremde Nummer  (Etikett des bisherigen Lieferanten)
 * Alle drei gehen an DENSELBEN Endpunkt /api/b2b/finder/suggest — er erkennt eigene
 * Nummern zuerst und loest fremde ueber die Kreuzreferenz auf. Es gibt bewusst keinen
 * zweiten Aufloeser hier.
 *
 * ⚠️⚠️ Der Name des Mitbewerbers erscheint NIRGENDS (gleiche Regel wie im Artikelfinder).
 * Gezeigt wird nur „Deine Nr. …" — die Eingabe selbst.
 *
 * ⚠️ Menge je Scan: 1 VPE, oder die Nachbestellmenge der Firma aus
 * /api/b2b/labels/mengen. Der Warenkorb zaehlt Verkaufseinheiten (wie bulk-import.js).
 *
 * ⚠️ Kamera im Browser: Android liest nativ (BarcodeDetector). Das iPhone liest QR ueber
 * jsQR und Code128 ueber den eigenen Leser weiter unten (seit 20.10.2026 — vorher las das
 * iPhone gar keine Strichcodes). Die Kamera-App des iPhones fuehrt ueber den QR-Link
 * hierher; auch dann landet der Artikel in der Sammelliste (Schritt [14]).
 *
 * Texte nur ueber textContent, nie innerHTML mit Daten.
 *
 * ⭐ KEINE MODI MEHR (19.10.2026). Jeder Scan landet in der Sammelliste; was damit
 * passiert, entscheidet man UNTEN an der Liste:
 *   1. Sofort kaufen     Kauf auf Rechnung HIER auf der Seite (seit 20.10.2026): Adresse,
 *                        Versand, Uebersicht mit Kundenpreisen, Bestellung — ohne Warenkorb
 *   2. In den Warenkorb  Warenkorb bleibt im Shop sicht- und bearbeitbar
 *   3. Favoritenliste    neue Liste ueber /api/b2b/favorites/import (Menge in VPE)
 *   4. Preise vergleichen nur bei fremden Nummern — HIER auf der Seite (seit 20.10.2026)
 *
 * ⚠️ ABNAHME-WEICHE: Setzt die Seite `window.EtikettAbnahme` (nur die Abnahme im
 * Dashboard, EtikettScanVorschau), werden Warenkorb, Rechnungskauf und Anfrage an den
 * Verkauf NUR angezeigt, nicht ausgefuehrt; die Mengen kommen vom Server mit. Im Shop
 * gibt es dieses Objekt nicht — dort laeuft alles wie beschrieben.
 */
(function () {
  'use strict';

  var SESSION_KEY = 'b2b_session';
  var LISTE_KEY   = 'etikett_scanliste';
  var CHUNK       = 50;
  var SPERRE_MS   = 2500;   // derselbe Code innerhalb dieser Zeit = derselbe Scan

  var el = {};
  var liste = [];
  var mengen = {};          // sku (klein) -> VPE
  var zuletzt = { code: '', zeit: 0 };
  var strom = null;

  function abnahme() { return window.EtikettAbnahme || null; }

  function $(id) { return document.getElementById(id); }
  function show(n) { if (n) n.style.display = ''; }
  function hide(n) { if (n) n.style.display = 'none'; }

  function cfg() {
    var c = window.b2bConfig || {};
    return { basis: (c.apiBase || 'https://pim.schaltschrank24.ch').replace(/\/+$/, ''), key: c.apiKey || '' };
  }

  function session() {
    try {
      var s = JSON.parse(localStorage.getItem(SESSION_KEY) || 'null');
      if (!s || (s.expiresAt && new Date(s.expiresAt) < new Date())) { return null; }
      return s;
    } catch (e) { return null; }
  }

  // ── Speicher ──────────────────────────────────────────────────────────────

  function laden() {
    try { liste = JSON.parse(localStorage.getItem(LISTE_KEY) || '[]') || []; } catch (e) { liste = []; }
  }
  function speichern() {
    try { localStorage.setItem(LISTE_KEY, JSON.stringify(liste)); } catch (e) { /* voll/privat: nur im Speicher */ }
  }
  function lokal(pfad) {
    return window.localizeUrl ? window.localizeUrl(pfad) : pfad;
  }

  // ── Meldungen ─────────────────────────────────────────────────────────────

  function meldung(text, art) {
    el.meldung.textContent = text;
    el.meldung.className = 'sc-meldung' + (art ? ' sc-meldung--' + art : '');
    show(el.meldung);
  }

  // ── Code → Nummer ─────────────────────────────────────────────────────────

  /** Aus unserem Etikett-Link die SKU holen; alles andere bleibt, wie es ist. */
  function nummerAus(code) {
    code = String(code || '').trim();
    if (/^https?:\/\//i.test(code)) {
      try {
        var u = new URL(code);
        var s = u.searchParams.get('s');
        if (s) { return s.trim(); }
      } catch (e) { /* kein gueltiger Link — als Nummer behandeln */ }
    }
    return code;
  }

  // ── Aufloesen ─────────────────────────────────────────────────────────────

  function aufloesen(nr) {
    var body = new URLSearchParams();
    body.append('nr', nr);
    return fetch(cfg().basis + '/api/b2b/finder/suggest', {
      method: 'POST',
      headers: { 'X-Api-Key': cfg().key, 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body
    }).then(function (r) {
      if (!r.ok) { throw new Error(r.status === 429 ? 'Zu viele Scans in kurzer Zeit — bitte kurz warten.' : 'Suche gerade nicht erreichbar.'); }
      return r.json();
    });
  }

  /** Gibt immer ein Promise zurueck — der QR-Link-Scan wartet darauf (siehe init). */
  function mengenLaden() {
    if (abnahme()) {
      var m = abnahme().mengen || {};
      Object.keys(m).forEach(function (k) { mengen[k.toLowerCase()] = m[k]; });
      return Promise.resolve();
    }
    var s = session();
    if (!s || !s.token || !cfg().key) { return Promise.resolve(); }
    return fetch(cfg().basis + '/api/b2b/labels/mengen', {
      headers: { 'X-Api-Key': cfg().key, 'Authorization': 'Bearer ' + s.token }
    }).then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        (d && d.mengen || []).forEach(function (m) { mengen[String(m.sku).toLowerCase()] = m.menge_vpe; });
      })
      .catch(function () { /* ohne Mengen gilt 1 VPE — kein Fehler fuer den Kunden */ });
  }

  function vpeFuer(sku) {
    return mengen[String(sku).toLowerCase()] || 1;
  }

  /**
   * Einen Scan verarbeiten — er landet immer in der Sammelliste.
   * @param {string}  code
   * @param {boolean} vonLink  kam ueber /pages/scan?s= (Kamera-App des Telefons)
   */
  function scan(code, vonLink) {
    var nr = nummerAus(code);
    if (nr.length < 3) { meldung('Zu kurz — bitte die ganze Nummer scannen.', 'fehler'); return; }

    var jetzt = Date.now();
    if (nr === zuletzt.code && jetzt - zuletzt.zeit < SPERRE_MS) { return; }
    zuletzt = { code: nr, zeit: jetzt };

    hide(el.auswahl);
    el.auswahl.innerHTML = '';
    meldung('Suche ' + nr + ' …');

    aufloesen(nr).then(function (d) {
      var z = (d.zeilen || [])[0] || {};
      var treffer = z.treffer || [];

      if (z.status === 'ok' && treffer.length === 1) {
        rueckmeldung(true);
        hinzu(treffer[0], nr, vonLink);
      } else if (z.status === 'mehrdeutig' && treffer.length > 1) {
        auswahl(nr, treffer, 'Mehrere Artikel passen zu ' + nr + ' — bitte wählen:', vonLink);
      } else if ((d.vorschlaege || []).length) {
        // ⚠️ Ein Texttreffer ist geraten, keine Zuordnung — darum ausdruecklich so benannt.
        auswahl(nr, d.vorschlaege, 'Keine Zuordnung zu ' + nr + '. Vorschläge (bitte prüfen):', vonLink);
        anfrageAnbieten(nr);
      } else {
        rueckmeldung(false);
        meldung('Zu ' + nr + ' haben wir noch keine Zuordnung.', 'hinweis');
        anfrageAnbieten(nr);
      }
    }).catch(function (e) {
      rueckmeldung(false);
      meldung(e.message || 'Das hat gerade nicht geklappt.', 'fehler');
    });
  }

  /**
   * Rueckmeldung zum Scan — edel statt laut: Mit Kamera leuchtet der Bildrahmen kurz gruen
   * und ein Haken zeichnet sich (CSS in sections/scan.liquid), auf Android vibriert es kurz.
   * Ohne Kamera (Handscanner, Tippen) leuchtet das Eingabefeld. Kein Ton.
   * Bei „keine Zuordnung" ein kurzer bernsteinfarbener Puls, damit man den Unterschied spuert.
   */
  var rueckmeldungUhr = null;
  function rueckmeldung(ok) {
    var ziel = el.rahmen && el.rahmen.style.display !== 'none' ? el.rahmen : el.feld;
    // Ton nur beim Kamera-Scan — Handscanner piepen selbst.
    if (ziel === el.rahmen && el.rahmen !== el.video) { tonSpielen(ok); }
    var klasse = ziel === el.rahmen ? (ok ? 'ist-treffer' : 'ist-fehl') : (ok ? 'ist-ok' : 'ist-fehl');
    if (!ziel) { return; }
    ziel.classList.remove('ist-treffer', 'ist-fehl', 'ist-ok');
    void ziel.offsetWidth;   // Animation neu starten, auch beim zweiten Treffer in Folge
    ziel.classList.add(klasse);
    clearTimeout(rueckmeldungUhr);
    rueckmeldungUhr = setTimeout(function () { ziel.classList.remove(klasse); }, ok ? 1100 : 700);
    haptik(ok);
  }

  /**
   * Leichte Haptik. Android: navigator.vibrate. iPhone (iOS 18+): Safari hat kein vibrate,
   * gibt aber beim Umschalten eines Schalter-Kaestchens (`<input type="checkbox" switch>`)
   * eine Haptik — das versteckte Label in sections/scan.liquid wird dafuer angeklickt.
   * ⚠️ Ob iOS das auch ohne direktes Antippen (Kamera-Treffer) ausloest, haengt von der
   * iOS-Version ab; schlimmstenfalls passiert nichts.
   */
  function haptik(ok) {
    if (navigator.vibrate) {
      try { navigator.vibrate(ok ? 35 : [25, 60, 25]); } catch (e) { /* egal */ }
      return;
    }
    var label = $('sc-haptik-label');
    if (!label) { return; }
    try {
      label.click();
      if (!ok) { setTimeout(function () { label.click(); }, 120); }   // doppelt = „nicht gefunden"
    } catch (e) { /* egal */ }
  }

  // ── Leiser Scan-Ton ───────────────────────────────────────────────────────
  //
  // ⭐ Ersatz fuer die Haptik, die Safari bei Kamera-Treffern nicht erlaubt (nur nach einer
  // Beruehrung). Web Audio, KEINE Tondatei: ein kurzer, weicher Sinus-„Tick" bei Treffer,
  // zwei tiefere gedaempfte Toene ohne Zuordnung. Bewusst leise (Gain 0.05).
  //
  // ⚠️ Freigeschaltet wird der Ton beim Antippen von „Kamera" (tonBereit() im Klick) — anders
  // spielt Safari nichts. audioSession „ambient" (iOS 17+): folgt dem Stummschalter.

  var TON_KEY = 'etikett_scanton';
  var tonKontext = null;

  function tonAn() {
    try { return localStorage.getItem(TON_KEY) !== 'aus'; } catch (e) { return true; }
  }

  function tonKnopfZeichnen() {
    var b = $('sc-ton');
    if (!b) { return; }
    var an = tonAn();
    b.setAttribute('aria-pressed', an ? 'true' : 'false');
    b.setAttribute('aria-label', an ? 'Scan-Ton ausschalten' : 'Scan-Ton einschalten');
  }

  /** Im Klick auf „Kamera" aufrufen — erst dann darf Safari Ton abspielen. */
  function tonBereit() {
    try {
      if (navigator.audioSession) { navigator.audioSession.type = 'ambient'; }
      var AC = window.AudioContext || window.webkitAudioContext;
      if (!AC) { return; }
      if (!tonKontext) { tonKontext = new AC(); }
      if (tonKontext.state === 'suspended') { tonKontext.resume(); }
    } catch (e) { tonKontext = null; }
  }

  function tonSpielen(ok) {
    if (!tonAn() || !tonKontext) { return; }
    try {
      var jetzt = tonKontext.currentTime;
      var toene = ok ? [[1760, 0, 0.11]] : [[520, 0, 0.09], [440, 0.13, 0.11]];
      toene.forEach(function (t) {
        var osz = tonKontext.createOscillator();
        var laut = tonKontext.createGain();
        osz.type = 'sine';
        osz.frequency.setValueAtTime(t[0], jetzt + t[1]);
        // Weich ein- und ausblenden — kein Knacken, kein Piepen.
        laut.gain.setValueAtTime(0.0001, jetzt + t[1]);
        laut.gain.exponentialRampToValueAtTime(0.05, jetzt + t[1] + 0.012);
        laut.gain.exponentialRampToValueAtTime(0.0001, jetzt + t[1] + t[2]);
        osz.connect(laut);
        laut.connect(tonKontext.destination);
        osz.start(jetzt + t[1]);
        osz.stop(jetzt + t[1] + t[2] + 0.02);
      });
    } catch (e) { /* ohne Ton weiter */ }
  }

  /** „Stück" → „Stk", „m" bleibt — Zahl mit Tausender-Apostroph, wie im Shop. */
  function einheitKurz(sub) { return sub === 'm' ? 'm' : 'Stk'; }
  function zahlCh(n) {
    var s = (Math.round(n * 1000) / 1000).toString().split('.');
    return s[0].replace(/\B(?=(\d{3})+(?!\d))/g, "'") + (s[1] ? '.' + s[1] : '');
  }

  function auswahl(nr, treffer, text, vonLink) {
    meldung(text, 'hinweis');
    el.auswahl.innerHTML = '';
    treffer.slice(0, 8).forEach(function (t) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'sc-knopf sc-knopf--leer';
      var vt = t.unterschied || t.vt || '';
      b.textContent = t.sku + ' — ' + (t.title || '') + (vt ? ' · ' + vt : '');
      b.addEventListener('click', function () { hide(el.auswahl); rueckmeldung(true); hinzu(t, nr, vonLink); });
      el.auswahl.appendChild(b);
    });
    show(el.auswahl);
  }

  /** Nummer ohne Zuordnung an den Verkauf — bestehender Weg des Artikelfinders. */
  function anfrageAnbieten(nr) {
    var s = session();
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'sc-knopf sc-knopf--leer';
    b.textContent = 'Nummer an unseren Verkauf schicken';
    b.addEventListener('click', function () {
      if (abnahme()) {
        meldung('ABNAHME: Im Shop ginge jetzt eine Mail mit „' + nr + '" an den Verkauf. Hier wird nichts gesendet.', 'hinweis');
        hide(el.auswahl);
        return;
      }
      if (!s || !s.email) { meldung('Bitte melde dich an — dann können wir dir antworten.', 'hinweis'); return; }
      var body = new URLSearchParams();
      body.append('email', s.email);
      body.append('nummern[]', nr);
      body.append('bemerkung', 'Gescannt auf der Etiketten-Scan-Seite.');
      fetch(cfg().basis + '/api/b2b/finder/anfrage', {
        method: 'POST',
        headers: { 'X-Api-Key': cfg().key, 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body
      }).then(function (r) { return r.json(); })
        .then(function () { meldung('Danke — unser Verkauf meldet sich zu ' + nr + '.', 'ok'); hide(el.auswahl); })
        .catch(function () { meldung('Anfrage nicht gesendet. Bitte versuche es erneut.', 'fehler'); });
    });
    el.auswahl.appendChild(b);
    show(el.auswahl);
  }

  // ── Liste ─────────────────────────────────────────────────────────────────

  function hinzu(t, eingabe) {
    var vpe = vpeFuer(t.sku);
    var fremd = t.ihre_nummer ? true : false;
    var pos = {
      // `unterschied` bei Nummerntreffern (Resolver), `vt` bei Textvorschlaegen (Index).
      sku: t.sku, id: t.id, title: t.title || '', vt: t.unterschied || t.vt || '',
      menge: vpe, art: t.art || null, eingabe: fremd ? eingabe : null, img: t.img || null,
      // Inhalt einer VPE (z. B. 500 Stk, 12 m) — damit man sieht, wie viel man wirklich bestellt.
      suq: t.suq && t.suq > 0 ? Number(t.suq) : 1, sub: t.sub || 'Stück',
      // Fuer die Favoritenliste (Produktlink und Gruppierung nach Kategorie).
      handle: t.handle || '', cat: t.cat || null
    };

    var da = null;
    liste.forEach(function (p) { if (p.sku.toLowerCase() === pos.sku.toLowerCase()) { da = p; } });
    if (da) {
      da.menge += vpe; da.suq = da.suq || pos.suq; da.sub = da.sub || pos.sub;
      // Zuerst ueber unsere Nummer, dann ueber die fremde gescannt: die fremde merken,
      // sonst fehlt der Artikel beim „Vergleichen".
      if (!da.eingabe && pos.eingabe) { da.eingabe = pos.eingabe; da.art = pos.art; }
    } else { liste.push(pos); }
    speichern();
    neuSku = pos.sku.toLowerCase();   // diese Zeile gleitet beim Zeichnen ein
    zeichnen();

    var text = pos.sku + ' — ' + pos.title + ' (+' + vpe + ' VPE)';
    if (fremd) {
      text = 'Deine Nr. ' + eingabe + ' → unser Artikel ' + text;
      if (pos.art === 'gleichwertig') { text += ' · gleichwertig, bitte Masse prüfen'; }
      if (pos.art === 'alternative') { text += ' · Alternative, weicht ab'; }
    }
    meldung(text, 'ok');
  }

  var neuSku = null;

  function zeichnen() {
    el.liste.innerHTML = '';
    var summe = 0;
    var gesamt = {};   // Einheit → Summe (Stk und m getrennt)
    liste.forEach(function (p, i) {
      summe += p.menge;
      var suq = p.suq && p.suq > 0 ? p.suq : 1;
      var eh = einheitKurz(p.sub);
      gesamt[eh] = (gesamt[eh] || 0) + p.menge * suq;
      var z = document.createElement('div');
      z.className = 'sc-zeile' + (neuSku && p.sku.toLowerCase() === neuSku ? ' ist-neu' : '');

      // Produktbild — beim Scannen am Lagerfach erkennt man den Artikel am Bild schneller
      // als an der Nummer. Ohne Bild bleibt die graue Flaeche, damit die Zeilen fluchten.
      var bild = document.createElement(p.img ? 'img' : 'span');
      bild.className = 'sc-bild';
      if (p.img) { bild.src = p.img; bild.alt = ''; bild.loading = 'lazy'; }
      z.appendChild(bild);

      var info = document.createElement('div');
      var sku = document.createElement('div');
      sku.className = 'sc-zeile__sku';
      sku.textContent = p.sku;
      if (p.art && p.art !== 'exakt') {
        var a = document.createElement('span');
        a.className = 'sc-zeile__art';
        a.textContent = p.art === 'gleichwertig' ? 'gleichwertig' : 'Alternative';
        sku.appendChild(a);
      }
      var t = document.createElement('div');
      t.className = 'sc-zeile__info';
      t.textContent = p.title + (p.vt ? ' · ' + p.vt : '') + (p.eingabe ? ' · Deine Nr. ' + p.eingabe : '');
      info.appendChild(sku);
      info.appendChild(t);
      // Was in EINER VPE steckt — „VPE 500 Stk" bzw. „VPE 12 m"; bei Einzelstueck „je 1 Stk".
      var vpeInfo = document.createElement('span');
      vpeInfo.className = 'sc-zeile__vpe';
      vpeInfo.textContent = suq > 1 ? 'VPE ' + zahlCh(suq) + ' ' + eh : 'je 1 ' + eh;
      info.appendChild(vpeInfo);

      // Menge mit −/+ — am Handy mit Handschuh trifft man das Zahlenfeld schlecht.
      function setze(n) {
        p.menge = Math.max(1, Math.min(999, n || 1));
        speichern();
        zeichnen();
      }
      var menge = document.createElement('div');
      menge.className = 'sc-menge';
      var minus = document.createElement('button');
      minus.type = 'button';
      minus.textContent = '−';
      minus.setAttribute('aria-label', 'Eine VPE weniger');
      minus.addEventListener('click', function () { setze(p.menge - 1); });
      var m = document.createElement('input');
      m.type = 'number';
      m.min = '1';
      m.max = '999';
      m.inputMode = 'numeric';
      m.value = String(p.menge);
      m.setAttribute('aria-label', 'Menge in VPE für ' + p.sku);
      m.addEventListener('change', function () { setze(parseInt(m.value, 10)); });
      var plus = document.createElement('button');
      plus.type = 'button';
      plus.textContent = '+';
      plus.setAttribute('aria-label', 'Eine VPE mehr');
      plus.addEventListener('click', function () { setze(p.menge + 1); });
      var einheit = document.createElement('small');
      einheit.textContent = 'VPE';
      menge.appendChild(minus);
      menge.appendChild(m);
      menge.appendChild(plus);
      menge.appendChild(einheit);
      // Daneben die tatsaechliche Bestellmenge, beschriftet: „Gesamtmenge 1'500 Stk".
      var mengeBox = document.createElement('div');
      mengeBox.className = 'sc-mengebox';
      var summeZeile = document.createElement('span');
      summeZeile.className = 'sc-menge-summe';
      var beschriftung = document.createElement('small');
      beschriftung.textContent = 'Gesamtmenge';
      var fett = document.createElement('b');
      fett.textContent = zahlCh(p.menge * suq) + ' ' + eh;
      summeZeile.appendChild(beschriftung);
      summeZeile.appendChild(fett);
      mengeBox.appendChild(menge);
      mengeBox.appendChild(summeZeile);

      var x = document.createElement('button');
      x.type = 'button';
      x.className = 'sc-weg';
      x.textContent = '×';
      x.setAttribute('aria-label', p.sku + ' entfernen');
      x.addEventListener('click', function () { liste.splice(i, 1); speichern(); zeichnen(); });

      z.appendChild(info);
      z.appendChild(mengeBox);
      z.appendChild(x);
      el.liste.appendChild(z);
    });
    neuSku = null;   // nur einmal einblenden, nicht bei jedem Neuzeichnen

    var summen = Object.keys(gesamt).map(function (eh) { return zahlCh(gesamt[eh]) + ' ' + eh; }).join(' + ');
    el.anzahl.textContent = liste.length ? liste.length + ' Artikel · ' + summe + ' VPE · ' + summen : '';
    var leer = liste.length === 0;
    [el.sofort, el.warenkorb, el.favorit, el.leeren].forEach(function (b) { if (b) { b.disabled = leer; } });
    // „Vergleichen" nur, wenn mindestens eine fremde Nummer gescannt wurde.
    var fremde = fremdeNummern().length;
    if (el.vergleich) {
      el.vergleich.style.display = fremde ? '' : 'none';
      var z = el.vergleich.querySelector('small');
      if (z) { z.textContent = fremde + (fremde === 1 ? ' fremde Nummer' : ' fremde Nummern'); }
    }
    if (el.aktionen) { el.aktionen.classList.toggle('mit-vergleich', fremde > 0); }
    korbLeisteZeichnen();
    // Offene Kasse: Liste geaendert (Menge, entfernt, neu gescannt) → Uebersicht neu holen.
    // Bis sie da ist, bleibt „Zahlungspflichtig bestellen" gesperrt (siehe vorschauHolen).
    if (kasse.offen) { vorschauHolen(400); }
  }

  /** Die gescannten Nummern des bisherigen Lieferanten (ohne Doppelte). */
  function fremdeNummern() {
    var gesehen = {};
    return liste.map(function (p) { return p.eingabe; }).filter(function (n) {
      if (!n || gesehen[n]) { return false; }
      gesehen[n] = true;
      return true;
    });
  }

  // ── Warenkorb ─────────────────────────────────────────────────────────────

  function addUrl() {
    return lokal('/cart/add.js');
  }

  /**
   * Positionen in Bloecken zu 50, NACHEINANDER — parallele Adds verlieren bei Shopify
   * Zeilen (siehe bulk-import.js).
   */
  /**
   * Abnahme: statt /cart/add.js einen angezeigten Warenkorb fuehren. Der Link
   * „im Shop ansehen" ist ein Shopify-Warenkorb-Permalink (/cart/<id>:<menge>,…) —
   * er prueft, ob Varianten-IDs und Mengen im echten Shop stimmen.
   */
  function abnahmeKorb(positionen) {
    var a = abnahme();
    a.korb = a.korb || [];
    positionen.forEach(function (p) {
      var da = null;
      a.korb.forEach(function (k) { if (k.id === p.id) { da = k; } });
      if (da) { da.menge += p.menge; } else { a.korb.push({ id: p.id, sku: p.sku, title: p.title, menge: p.menge }); }
    });

    // ⚠️ Kein eigener Abnahme-Kasten mehr (20.10.2026): Die Warenkorb-Karte (korbKarte) zeigt
    // in Shop und Abnahme dasselbe und bietet direkt „Jetzt bestellen" — der alte Kasten mit
    // „Zum Rechnungsabschluss" stand doppelt darunter.
    return Promise.resolve();
  }

  /** Abnahme-Kasten unter der Liste anlegen oder leeren. */
  function abBox(id) {
    var box = $(id);
    if (!box) {
      box = document.createElement('div');
      box.id = id;
      box.className = 'sc-ab';
      el.liste.parentNode.appendChild(box);
    }
    box.innerHTML = '';
    return box;
  }

  /** Eine Zeile „Bezeichnung / Nummer … Wert" — nur textContent. */
  function abZeile(text, klein, wert, klasse) {
    var z = document.createElement('div');
    z.className = 'sc-ab-zeile' + (klasse ? ' ' + klasse : '');
    var l = document.createElement('span');
    l.textContent = text;
    if (klein) {
      var s = document.createElement('small');
      s.textContent = klein;
      l.appendChild(s);
    }
    var r = document.createElement('span');
    r.textContent = wert;
    z.appendChild(l);
    z.appendChild(r);
    return z;
  }

  /**
   * Abnahme: der Rechnungsabschluss mit ECHTEN Preisen und Versand des Testkunden —
   * gerechnet wie /api/b2b/preview-invoice-order (DraftOrderBuilder), aber ohne Bestellung.
   */
  function abnahmeRechnung() {
    var a = abnahme();
    var korb = a.korb || [];
    var box = abBox('sc-abnahme-rechnung');
    if (!korb.length) { meldung('Der Warenkorb ist leer — erst scannen.', 'hinweis'); return; }
    if (!a.email) { meldung('Für den Rechnungsabschluss oben einen Testkunden setzen.', 'hinweis'); return; }

    meldung('Rechnungsabschluss wird berechnet …');
    fetch(a.rechnungUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': a.csrf || '' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: korb.map(function (k) { return { sku: k.sku, variant_id: k.id, quantity: k.menge }; }) })
    }).then(function (r) {
      return r.json().then(function (d) { if (!r.ok) { throw new Error(d.error || ('Antwort ' + r.status)); } return d; });
    }).then(function (d) {
      hide(el.meldung);
      rechnungZeichnen(box, d, korb);
      box.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }).catch(function (e) {
      meldung(e.message || 'Rechnungsabschluss nicht berechenbar.', 'fehler');
    });
  }

  function geld(wert) {
    var n = parseFloat(wert);
    if (!isFinite(n)) { return '–'; }
    return n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, "'");
  }

  function rechnungZeichnen(box, d, korb) {
    var titel = {};
    korb.forEach(function (k) { titel[String(k.sku).toLowerCase()] = k.title; });

    var kopf = document.createElement('h3');
    kopf.textContent = 'Bestellübersicht · Kauf auf Rechnung';
    box.appendChild(kopf);

    (d.lines || []).forEach(function (ln) {
      box.appendChild(abZeile(
        titel[String(ln.sku || '').toLowerCase()] || ln.sku || ('Variante ' + ln.variant_id),
        (ln.sku || '') + ' · ' + ln.quantity + ' × CHF ' + geld(ln.unit_price),
        'CHF ' + geld(ln.line_total)
      ));
    });

    var sum = document.createElement('div');
    sum.className = 'sc-ab-summe';
    sum.appendChild(abZeile('Zwischensumme', null, 'CHF ' + geld(d.subtotal)));
    sum.appendChild(abZeile('Versand', null, d.shipping ? d.shipping.title + ' · CHF ' + geld(d.shipping.price) : 'wird im Shop gewählt'));
    sum.appendChild(abZeile('Total exkl. MWST', null, 'CHF ' + geld(d.total), 'sc-ab-total'));
    box.appendChild(sum);

    var noten = [];
    if (d.missing_skus && d.missing_skus.length) { noten.push('Nicht bestellbar: ' + d.missing_skus.join(', ') + '.'); }
    if (d.prices_complete === false) { noten.push('Für einzelne Positionen fehlt ein verbindlicher Preis.'); }
    noten.push('Abnahme: Preise und Versand sind echt (Konditionen des Testkunden). Bestellt wird hier nichts.');
    var hinweis = document.createElement('p');
    hinweis.className = 'sc-ab-hinweis';
    hinweis.textContent = noten.join(' ');
    box.appendChild(hinweis);

    var knopf = document.createElement('button');
    knopf.type = 'button';
    knopf.className = 'sc-knopf sc-knopf--rot';
    knopf.disabled = true;
    knopf.textContent = 'Zahlungspflichtig bestellen (in der Abnahme gesperrt)';
    box.appendChild(knopf);
  }

  function inDenWarenkorb(positionen, blockFertig) {
    if (abnahme()) {
      return abnahmeKorb(positionen).then(function () { if (blockFertig) { blockFertig(positionen); } });
    }
    var bloecke = [];
    for (var i = 0; i < positionen.length; i += CHUNK) { bloecke.push(positionen.slice(i, i + CHUNK)); }

    return bloecke.reduce(function (kette, block) {
      return kette.then(function () {
        return fetch(addUrl(), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: block.map(function (p) { return { id: p.id, quantity: p.menge }; }) })
        }).then(function (r) {
          if (!r.ok) {
            return r.json().catch(function () { return {}; }).then(function (j) {
              throw new Error(j.description || j.message || 'Warenkorb hat abgelehnt (' + r.status + ').');
            });
          }
          if (blockFertig) { blockFertig(block); }
        });
      });
    }, Promise.resolve()).then(korbAuffrischen);
  }

  /** Warenkorb-Symbol und Seitenleiste des Shops auf den neuen Stand bringen. */
  function korbAuffrischen() {
    if (typeof window.B2BRefreshCart === 'function') { setTimeout(window.B2BRefreshCart, 0); }
    try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (e) { /* egal */ }
  }

  /**
   * Aktion 2: alles in den Warenkorb des Shops.
   *
   * ⭐ 20.10.2026: Danach eine BESTAETIGUNG, die beim Shop nachfragt (/cart.js), statt nur
   * „erledigt" zu behaupten — und ein „Rückgängig", das genau diese Mengen wieder abzieht und
   * die Artikel in die Scanliste zurueckholt.
   */
  function allesInDenWarenkorb() {
    if (!liste.length) { return; }
    el.warenkorb.disabled = true;
    meldung('Lege ' + liste.length + ' Artikel in den Warenkorb …');
    hide(el.korbBox);
    var gelegt = [];
    // ⚠️ Jeder angenommene Block verlaesst die Liste SOFORT. Scheitert ein spaeterer
    // Block, steht nur noch der Rest da — ein erneuter Versuch legt nichts doppelt.
    inDenWarenkorb(liste.slice(), function (block) {
      gelegt = gelegt.concat(block);
      liste = liste.filter(function (p) { return block.indexOf(p) === -1; });
      speichern();
    }).then(function () {
      imKorbMerken(gelegt);
      zeichnen();
      hide(el.meldung);
      korbBestaetigen();
    }, function (e) {
      // ⚠️ Nur der noch nicht angenommene Rest bleibt stehen — erneut versuchen ist sicher.
      imKorbMerken(gelegt);
      zeichnen();
      meldung(e.message + ' Was noch nicht im Warenkorb ist, steht weiter in der Liste.', 'fehler');
      if (gelegt.length) { korbBestaetigen(); }
    });
  }

  // ── Scan-Artikel im Warenkorb — dauerhaft gemerkt (20.10.2026) ──────────────
  //
  // ⚠️⚠️ WARUM: „In den Warenkorb" nimmt die Artikel aus der Scanliste. Das „Rückgängig" lebte
  // nur auf der Bestaetigungskarte im Speicher der Seite — nach Schliessen oder Neuladen war die
  // Liste leer, alle Aktionen gesperrt, „Vergleichen" weg (Rueckmeldung: „bin haengen geblieben").
  // Jetzt steht in localStorage, was aus dem Scan im Warenkorb liegt; die Leiste ueber der Liste
  // fuehrt jederzeit zurueck, und beim Laden wird mit /cart.js abgeglichen.

  var KORB_KEY = 'etikett_scan_im_korb';
  var imKorb = [];

  function imKorbLaden() {
    try { imKorb = JSON.parse(localStorage.getItem(KORB_KEY) || '[]') || []; } catch (e) { imKorb = []; }
  }
  function imKorbSpeichern() {
    try { localStorage.setItem(KORB_KEY, JSON.stringify(imKorb)); } catch (e) { /* nur im Speicher */ }
  }
  function imKorbMerken(gelegt) {
    gelegt.forEach(function (p) {
      var da = null;
      imKorb.forEach(function (x) { if (x.sku.toLowerCase() === p.sku.toLowerCase()) { da = x; } });
      if (da) { da.menge += p.menge; } else { imKorb.push(JSON.parse(JSON.stringify(p))); }
    });
    imKorbSpeichern();
  }

  /** Beim Laden: nur behalten, was wirklich noch im Shop-Warenkorb liegt (hoechstens dessen Menge). */
  function imKorbAbgleichen() {
    if (abnahme() || !imKorb.length) { return; }
    fetch(lokal('/cart.js'), { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (korb) {
        if (!korb) { return; }
        var menge = {};
        (korb.items || []).forEach(function (i) { menge[i.variant_id] = (menge[i.variant_id] || 0) + i.quantity; });
        imKorb = imKorb.filter(function (p) { return menge[parseInt(p.id, 10)] > 0; });
        imKorb.forEach(function (p) { p.menge = Math.min(p.menge, menge[parseInt(p.id, 10)]); });
        imKorbSpeichern();
        zeichnen();
      })
      .catch(function () { /* Leiste bleibt wie gemerkt */ });
  }

  /** Leiste ueber der Liste: „N Artikel aus deinem Scan liegen im Warenkorb" + Zurueckholen. */
  function korbLeisteZeichnen() {
    var l = el.korbLeiste;
    if (!l) { return; }
    if (!imKorb.length) { hide(l); return; }
    l.innerHTML = '';
    l.appendChild(h('span', 'sc-korbleiste__text', imKorb.length + (imKorb.length === 1 ? ' Artikel' : ' Artikel')
      + ' aus deinem Scan ' + (imKorb.length === 1 ? 'liegt' : 'liegen') + ' im Warenkorb'));
    // Zwei Knoepfe statt „Ansehen / zurückholen" (20.10.2026): Zurueckholen geht direkt, ohne die
    // Warenkorb-Karte zu oeffnen — dieselbe Funktion wie „Alle aus Warenkorb entfernen" dort.
    var knoepfe = h('span', 'sc-korbleiste__knoepfe');
    var ansehen = h('button', 'sc-korbleiste__knopf', 'Ansehen');
    ansehen.type = 'button';
    ansehen.addEventListener('click', function () { korbBestaetigen(); });
    var holen = h('button', 'sc-korbleiste__knopf', 'Alle zurückholen');
    holen.type = 'button';
    holen.setAttribute('aria-label', 'Alle Produkte aus dem Warenkorb zurück in die Scanliste');
    holen.addEventListener('click', function () { korbZurueck(imKorb.slice(), holen); });
    knoepfe.appendChild(ansehen);
    knoepfe.appendChild(holen);
    l.appendChild(knoepfe);
    show(l);
  }

  /** Warenkorb-Karte mit ALLEN Scan-Artikeln, die gerade im Warenkorb liegen. */
  function korbBestaetigen() {
    if (!imKorb.length) { hide(el.korbBox); return; }
    if (abnahme()) { korbKarte(null); return; }
    fetch(lokal('/cart.js'), { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; })
      .then(function (korb) { korbKarte(korb); });
  }

  function korbKarte(korb) {
    var box = el.korbBox;
    if (!box) { return; }
    box.innerHTML = '';
    box.className = 'sc-panel sc-korb';
    panelKopf(box, 'Im Warenkorb', function () { hide(box); });

    var imShop = {};
    ((korb && korb.items) || []).forEach(function (i) { imShop[i.variant_id] = (imShop[i.variant_id] || 0) + i.quantity; });
    var fehlt = korb ? imKorb.filter(function (p) { return !imShop[parseInt(p.id, 10)]; }) : [];
    var angekommen = imKorb.length - fehlt.length;

    // Erfolgsmeldung (20.10.2026: „Produkte im Warenkorb" — ohne Sinnbilder).
    var kopf = h('div', 'sc-korb__ok');
    kopf.appendChild(h('b', null, fehlt.length && angekommen
      ? angekommen + ' von ' + imKorb.length + ' Produkten im Warenkorb'
      : (fehlt.length ? 'Nicht mehr im Warenkorb' : 'Produkte im Warenkorb')));
    kopf.appendChild(h('span', null, abnahme()
      ? 'Abnahme: Der Warenkorb wird hier nur angezeigt.'
      : imKorb.length + (imKorb.length === 1 ? ' Produkt liegt' : ' Produkte liegen') + ' im Warenkorb des Shops'
        + (korb ? ' (insgesamt ' + korb.items.length + (korb.items.length === 1 ? ' Position' : ' Positionen') + ')' : '')
        + ' — oben rechts unter „Warenkorb".'));
    box.appendChild(kopf);

    // Je Artikel ein eigenes „Aus Warenkorb entfernen" (Beschriftung 20.10.2026) — man muss nicht
    // alles zuruecknehmen. Das Produkt verschwindet aus dem Shop-Warenkorb und steht danach wieder
    // in der Scanliste, damit nichts verloren geht.
    imKorb.forEach(function (p) {
      var suq = p.suq && p.suq > 0 ? p.suq : 1;
      var z = posZeile(p.img, p.title || p.sku, p.sku + (p.vt ? ' · ' + p.vt : ''),
        p.menge + ' VPE' + (suq > 1 ? ' = ' + zahlCh(p.menge * suq) + ' ' + einheitKurz(p.sub) : ''), null);
      if (korb && !imShop[parseInt(p.id, 10)]) { z.classList.add('ist-fehlt'); }
      var zurueck = h('button', 'sc-pos__zurueck', 'Aus Warenkorb entfernen');
      zurueck.type = 'button';
      zurueck.setAttribute('aria-label', p.sku + ' aus dem Warenkorb entfernen');
      zurueck.addEventListener('click', function () { korbZurueck([p], zurueck); });
      z.appendChild(zurueck);
      box.appendChild(z);
    });
    if (fehlt.length) {
      box.appendChild(h('p', 'sc-panel__hinweis', 'Nicht mehr im Warenkorb (bestellt oder dort entfernt): '
        + fehlt.map(function (p) { return p.sku; }).join(', ') + '. „Aus Warenkorb entfernen" legt sie trotzdem zurück in deine Liste.'));
    }

    // ⚠️⚠️ Anderes Geraet: Der Shopify-Warenkorb haengt am BROWSER, es gibt keine Konto-Synchronisierung.
    // Geraeteuebergreifend sind nur die Favoritenlisten (Server). Darum dieser Weg — und kein
    // Versprechen, das der Shop nicht haelt.
    if (!abnahme() && angekommen) {
      var geraet = h('div', 'sc-korb__geraet');
      geraet.appendChild(h('b', null, 'Auf einem anderen Gerät weitermachen?'));
      geraet.appendChild(h('span', null, 'Der Warenkorb gilt nur in diesem Browser. Sichere die Produkte als Favoritenliste — '
        + 'sie liegt in deinem Konto, und du legst sie am Computer mit einem Klick in den Warenkorb.'));
      var sichern = h('button', 'sc-knopf sc-knopf--leer sc-knopf--klein', 'Als Favoritenliste sichern');
      sichern.type = 'button';
      sichern.addEventListener('click', function () { favoritenOeffnen('korb'); });
      geraet.appendChild(sichern);
      box.appendChild(geraet);
    }

    var fuss = h('div', 'sc-panel__fuss');
    // Direkt bestellen (20.10.2026): dasselbe Formular wie „Sofort kaufen" (Kasse auf dieser
    // Seite: Lieferung, Adresse, Bestellnr., Uebersicht mit Kundenpreisen) — mit den Produkten,
    // die aus dem Scan im Warenkorb liegen. Nach der Bestellung zieht bestellen() sie aus dem
    // Shop-Warenkorb ab. KEIN checkout-gate.js mehr hier: das war ein zweites, anderes Formular.
    if (abnahme() || (angekommen && document.documentElement.classList.contains('b2b-invoice-eligible'))) {
      var best = h('button', 'sc-knopf sc-knopf--rot', 'Jetzt auf Rechnung bestellen');
      best.type = 'button';
      best.addEventListener('click', function () { sofortKaufen('korb'); });
      fuss.appendChild(best);
    }
    if (!abnahme()) {
      var ansehen = h('a', 'sc-knopf ' + (angekommen && document.documentElement.classList.contains('b2b-invoice-eligible') ? 'sc-knopf--leer' : 'sc-knopf--rot'),
        document.documentElement.classList.contains('b2b-invoice-eligible') ? 'Warenkorb ansehen' : 'Zum Warenkorb und bestellen');
      ansehen.href = lokal('/cart');
      fuss.appendChild(ansehen);
    }
    var alle = h('button', 'sc-knopf sc-knopf--leer', 'Alle aus Warenkorb entfernen');
    alle.type = 'button';
    alle.addEventListener('click', function () { korbZurueck(imKorb.slice(), alle); });
    fuss.appendChild(alle);
    var weiter = h('button', 'sc-knopf sc-knopf--leer', 'Weiter scannen');
    weiter.type = 'button';
    weiter.addEventListener('click', function () {
      hide(box);
      if (el.feld && window.self === window.top) { el.feld.focus(); }
    });
    fuss.appendChild(weiter);
    box.appendChild(fuss);
    fensterSchliessen('korb');
    show(box);
    box.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  /**
   * Immer nur EIN Fenster offen (20.10.2026: „wenn ich von Warenkorb auf Favoriten wechsle, muss
   * der Warenkorb verschwinden"). Jedes Fenster ruft das beim Oeffnen mit seinem Namen auf;
   * alle anderen schliessen. Die Kasse ueber kasseSchliessen(), damit ihr Zustand (offene
   * Vorschau, Lauf-Zaehler) mit zurueckgesetzt wird.
   * @param {string} ausser  'kasse' | 'vergleich' | 'korb' | 'fav'
   */
  function fensterSchliessen(ausser) {
    if (ausser !== 'kasse') { if (kasse.offen) { kasseSchliessen(); } else { hide(el.kasse); } }
    if (ausser !== 'vergleich') { hide(el.vergleichBox); }
    if (ausser !== 'korb') { hide(el.korbBox); }
    if (ausser !== 'fav') { hide(el.favForm); }
  }

  /**
   * Artikel aus dem Warenkorb zurueck in die Scanliste: genau ihre Menge abziehen (nicht die
   * Zeile loeschen — lag der Artikel vorher schon im Warenkorb, bleibt diese Menge stehen).
   */
  function korbZurueck(positionen, knopf) {
    knopf.disabled = true;
    var alterText = knopf.textContent;
    knopf.textContent = 'Wird zurückgeholt …';
    var fertig = function () {
      positionen.forEach(function (p) {
        var da = null;
        liste.forEach(function (x) { if (x.sku.toLowerCase() === p.sku.toLowerCase()) { da = x; } });
        if (da) { da.menge += p.menge; } else { liste.push(JSON.parse(JSON.stringify(p))); }
        imKorb = imKorb.filter(function (x) { return x.sku.toLowerCase() !== p.sku.toLowerCase(); });
      });
      speichern();
      imKorbSpeichern();
      zeichnen();
      if (imKorb.length) { korbBestaetigen(); } else { hide(el.korbBox); }
      meldung(positionen.length === 1
        ? positionen[0].sku + ' steht wieder in deiner Liste.'
        : 'Zurückgeholt — die Artikel stehen wieder in deiner Liste.', 'ok');
    };
    if (abnahme()) {
      var a = abnahme();
      (a.korb || []).forEach(function (k) {
        positionen.forEach(function (p) { if (k.id === p.id) { k.menge -= p.menge; } });
      });
      a.korb = (a.korb || []).filter(function (k) { return k.menge > 0; });
      var alt = $('sc-abnahme-korb');
      if (alt && !a.korb.length) { alt.parentNode.removeChild(alt); }
      fertig();
      return;
    }
    korbAbziehen(positionen).then(fertig, function () {
      knopf.disabled = false;
      knopf.textContent = alterText;
      meldungMitLink('Entfernen ging gerade nicht — bitte im Warenkorb selbst ändern.', 'Warenkorb ansehen', lokal('/cart'), 'fehler');
    });
  }

  /**
   * Genau diese Mengen aus dem SHOP-Warenkorb abziehen (/cart/update.js mit Zeilenschluessel) —
   * nicht die Zeile loeschen: lag der Artikel vorher schon im Warenkorb, bleibt diese Menge.
   * Gemeinsam fuer „Aus Warenkorb entfernen" und die Bestellung aus dem Warenkorb.
   * @return {Promise}  lehnt ab, wenn der Shop nicht mitspielt
   */
  function korbAbziehen(positionen) {
    if (abnahme() || !positionen.length) { return Promise.resolve(); }
    return fetch(lokal('/cart.js'), { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (r) { if (!r.ok) { throw new Error(); } return r.json(); })
      .then(function (korb) {
        var abziehen = {};
        positionen.forEach(function (p) { var id = parseInt(p.id, 10); abziehen[id] = (abziehen[id] || 0) + p.menge; });
        var updates = {};
        (korb.items || []).forEach(function (i) {
          if (abziehen[i.variant_id]) {
            var weg = Math.min(i.quantity, abziehen[i.variant_id]);
            abziehen[i.variant_id] -= weg;
            updates[i.key] = i.quantity - weg;
          }
        });
        if (!Object.keys(updates).length) { return { ok: true }; }   // lag schon nicht mehr dort
        return fetch(lokal('/cart/update.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates: updates })
        });
      })
      .then(function (r) {
        if (!r.ok) { throw new Error(); }
        korbAuffrischen();
      });
  }

  /**
   * Eine Positionszeile fuers Handy: Bild, Titel, Nummer, darunter klar die MENGE — und rechts
   * optional ein Betrag. Gemeinsam fuer Warenkorb-Bestaetigung und Bestelluebersicht.
   */
  function posZeile(img, titel, nummer, menge, betrag) {
    var z = h('div', 'sc-pos');
    var bild = h(img ? 'img' : 'span', 'sc-pos__bild');
    if (img) { bild.src = img; bild.alt = ''; bild.loading = 'lazy'; }
    z.appendChild(bild);
    var info = h('div', 'sc-pos__info');
    info.appendChild(h('div', 'sc-pos__titel', titel));
    info.appendChild(h('div', 'sc-pos__nr', nummer));
    info.appendChild(h('div', 'sc-pos__menge', menge));
    z.appendChild(info);
    if (betrag != null) { z.appendChild(h('div', 'sc-pos__betrag', betrag)); }
    return z;
  }

  /** Meldung mit einem Verweis dahinter — Text und Verweis nur ueber textContent. */
  function meldungMitLink(text, linkText, href, art) {
    meldung(text + (linkText ? ' ' : ''), art || 'ok');
    if (!linkText) { return; }
    var a = document.createElement('a');
    a.href = href;
    a.className = 'sc-meldung__link';
    a.textContent = linkText + ' →';
    el.meldung.appendChild(a);
  }

  // ── Hilfen fuer die Panels ─────────────────────────────────────────────────

  /** Element mit Klasse und Text — nie innerHTML mit Daten. */
  function h(tag, klasse, text) {
    var e = document.createElement(tag);
    if (klasse) { e.className = klasse; }
    if (text != null) { e.textContent = text; }
    return e;
  }

  function panelKopf(box, titel, zu) {
    var k = h('div', 'sc-panel__kopf');
    k.appendChild(h('h3', null, titel));
    var x = h('button', 'sc-panel__zu', '×');
    x.type = 'button';
    x.setAttribute('aria-label', 'Schliessen');
    x.addEventListener('click', zu);
    k.appendChild(x);
    box.appendChild(k);
  }

  /** Stueckpreis: unter einem Franken vier Stellen (0.0463) — wie im Artikelfinder. */
  function stueckpreis(n) {
    return n < 1 ? n.toFixed(4) : geld(n);
  }

  function titelZu(sku) {
    var t = '';
    liste.forEach(function (p) { if (p.sku.toLowerCase() === String(sku || '').toLowerCase()) { t = p.title; } });
    return t;
  }

  // ── Aktion 1: Kauf auf Rechnung DIREKT auf der Scan-Seite ─────────────────
  //
  // ⭐ 20.10.2026 („alles bequem vom Handy"): KEIN Umweg mehr ueber den Warenkorb. Bestellt
  // wird genau die Scanliste — ueber DIESELBEN Endpunkte wie der Rechnungskauf im Warenkorb
  // (checkout-gate.js): /preview-invoice-order fuer die verbindliche Uebersicht mit den
  // Kundenpreisen, /create-invoice-order fuer die Bestellung. Der Server prueft Anmeldung,
  // Rechnungsfreigabe, Preise und Versand selbst; hier wird nichts gerechnet.
  //
  // ⚠️⚠️ Bestellt wird EXAKT das Payload, das die Uebersicht gezeigt hat (kasse.payload). Aendert
  // sich danach Liste, Adresse oder Versand, wird die Uebersicht neu geholt und der Knopf ist
  // so lange gesperrt — derselbe Grundsatz wie im Warenkorb.
  // ⚠️ Der Shopify-Warenkorb bleibt unberuehrt: was dort liegt, wird NICHT mitbestellt.

  var kasse = { offen: false, adressen: [], adresseId: null, versand: 'standard', lauf: 0, payload: null, sendet: false, uhr: null };

  function kasseKopf(s) {
    var k = { 'Content-Type': 'application/json', 'X-Api-Key': cfg().key };
    if (s && s.token) { k.Authorization = 'Bearer ' + s.token; }
    return k;
  }

  /**
   * Quelle der Kasse (20.10.2026): die Scanliste („Sofort kaufen") oder die Produkte, die aus
   * dem Scan im Warenkorb liegen („Jetzt auf Rechnung bestellen" auf der Warenkorb-Karte) —
   * dasselbe Formular fuer beide Wege, statt des Rechnungskaufs aus checkout-gate.js.
   */
  var kasseQuelle = 'liste';
  function kassePositionen() { return kasseQuelle === 'korb' ? imKorb : liste; }

  function sofortKaufen(quelle) {
    kasseQuelle = quelle === 'korb' ? 'korb' : 'liste';   // Klick-Ereignis → Scanliste
    if (!kassePositionen().length) { return; }
    var s = session();
    if (!abnahme() && (!s || !s.email || !s.token)) {
      meldungMitLink('Für den Kauf auf Rechnung bitte zuerst anmelden — deine Liste bleibt erhalten.', 'Anmelden', lokal('/pages/konto'), 'hinweis');
      return;
    }
    fensterSchliessen('kasse');
    kasse.offen = true;
    kasse.adressen = abnahme() ? [] : ((s && s.addresses) || []).filter(function (a) { return a && String(a.address1 || '').trim(); });
    var def = kasse.adressen.filter(function (a) { return a.isDefault; })[0] || kasse.adressen[0];
    kasse.adresseId = def ? def.id : null;
    kasseZeichnen();
    show(el.kasse);
    el.kasse.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (!abnahme()) { adressenNachladen(s); }
    vorschauHolen();
  }

  /** Lieferadressen frisch aus dem Konto (wie checkout-gate.js: die Login-Antwort ist unvollstaendig). */
  function adressenNachladen(s) {
    if (!s.customerId) { return; }
    fetch(cfg().basis + '/api/b2b/addresses?email=' + encodeURIComponent(s.email) + '&customerId=' + encodeURIComponent(s.customerId), {
      headers: { 'X-Api-Key': cfg().key }
    }).then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
      if (!d || !d.addresses || !kasse.offen) { return; }
      var neu = d.addresses.filter(function (a) { return a && String(a.address1 || '').trim(); });
      if (!neu.length) { return; }
      var gleich = JSON.stringify(neu) === JSON.stringify(kasse.adressen);
      kasse.adressen = neu;
      if (kasse.adresseId !== 'neu' && !neu.some(function (a) { return a.id === kasse.adresseId; })) {
        var def = neu.filter(function (a) { return a.isDefault; })[0] || neu[0];
        kasse.adresseId = def.id;
        gleich = false;
      }
      if (!gleich) { kasseNeuZeichnen(); }
    }).catch(function () { /* die Adressen aus der Anmeldung genuegen */ });
  }

  function kassePayload(s) {
    var versandCfg = window.CG_SHIPPING || {};
    var payload = {
      customer_email: abnahme() ? abnahme().email : s.email,
      items: kassePositionen().map(function (p) {
        return { sku: p.sku, variant_id: parseInt(p.id, 10) || 0, quantity: Math.max(1, Math.round(p.menge)) };
      }),
      // ⚠️ B2B: der Versandbetrag ist laut Versandregel (shipping-policy.js) immer 0 — gratis
      // ab Schwelle, sonst „separat verrechnet". Entscheiden tut der Server.
      shipping: kasse.versand === 'pickup'
        ? { key: 'pickup', title: versandCfg.pickupLabel || 'Abholung', price: 0 }
        : { key: 'standard', title: versandCfg.flatLabel || 'Standardversand', price: 0 }
    };
    var a = null;
    if (kasse.adresseId === 'neu') {
      // Von Hand eingegeben (nur Schweiz — der Rechnungskauf liefert nicht ins Ausland).
      var wert = function (id) { var f = $(id); return f ? f.value.trim() : ''; };
      a = { company: wert('sc-neu-firma'), address1: wert('sc-neu-strasse'), zip: wert('sc-neu-plz'), city: wert('sc-neu-ort'), country: 'CH' };
      if (!a.address1 || !a.zip || !a.city) { payload.unvollstaendig = true; a = null; }
    } else {
      kasse.adressen.forEach(function (x) { if (x.id === kasse.adresseId) { a = x; } });
    }
    if (a) {
      payload.shipping_address = {
        first_name: (s && s.firstName) || '', last_name: (s && s.lastName) || '',
        company: a.company || '', address1: a.address1 || '', address2: a.address2 || '',
        zip: a.zip || '', city: a.city || '', country: a.country || '', phone: a.phone || ''
      };
    }
    var notizen = [];
    var po = $('sc-kasse-po'), kom = $('sc-kasse-kom');
    if (po && po.value.trim()) { notizen.push({ name: 'po_nummer', value: po.value.trim().slice(0, 25) }); }
    if (kom && kom.value.trim()) { notizen.push({ name: 'kommission', value: kom.value.trim().slice(0, 30) }); }
    if (notizen.length) { payload.note_attributes = notizen; }
    return payload;
  }

  /** Uebersicht neu holen — entprellt, ein Lauf-Zaehler verwirft veraltete Antworten. */
  function vorschauHolen(warten) {
    clearTimeout(kasse.uhr);
    kasse.payload = null;   // bis die neue Uebersicht da ist, darf nicht bestellt werden
    kasseKnopf();
    el.kasse.classList.add('ist-laed');
    kasse.uhr = setTimeout(function () {
      var mein = ++kasse.lauf;
      var s = session();
      var payload = kassePayload(s);
      if (!payload.items.length) { kasseSchliessen(); return; }
      if (payload.unvollstaendig) {
        el.kasse.classList.remove('ist-laed');
        kasseFehler('Bitte Strasse, PLZ und Ort der Lieferadresse ausfüllen.');
        return;
      }
      var a = abnahme();
      var anfrage = a
        // Abnahme: Vorschau ueber das Dashboard (Testkunde, ohne Bestellung).
        ? fetch(a.rechnungUrl, { method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': a.csrf || '' }, body: JSON.stringify({ items: payload.items }) })
        : fetch(cfg().basis + '/api/b2b/preview-invoice-order', { method: 'POST', headers: kasseKopf(s), body: JSON.stringify(payload) });
      anfrage.then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (d) { return { ok: r.ok, d: d }; });
      }).then(function (res) {
        if (mein !== kasse.lauf || !kasse.offen) { return; }
        el.kasse.classList.remove('ist-laed');
        var d = res.d || {};
        if (d.code === 'session_expired') { kasseFehler('Deine Anmeldung ist abgelaufen. Bitte melde dich neu an — die Liste bleibt.'); return; }
        if (!res.ok || (d.status && d.status !== 'preview') || !d.lines) {
          kasseFehler(d.error || 'Die Bestellübersicht konnte gerade nicht berechnet werden.');
          return;
        }
        kasse.payload = payload;
        uebersichtZeichnen(d);
        kasseKnopf();
      }).catch(function () {
        if (mein !== kasse.lauf) { return; }
        el.kasse.classList.remove('ist-laed');
        kasseFehler('Keine Verbindung — bitte gleich noch einmal versuchen.');
      });
    }, warten || 0);
  }

  function kasseZeichnen() {
    var box = el.kasse;
    box.innerHTML = '';
    box.className = 'sc-panel sc-kasse';
    panelKopf(box, 'Kauf auf Rechnung', kasseSchliessen);

    var s = session();
    if (s && s.email && !abnahme()) {
      box.appendChild(h('p', 'sc-panel__hinweis sc-kasse__wer', 'Bestellt als ' + s.email + ' · Bezahlung per Rechnung'));
    }

    // ⭐ Reihenfolge (dritter Durchgang 20.10.2026): erst die Eingaben, DARUNTER die Produkte.
    // ⚠️ Das Fenster wird EINMAL aufgebaut; danach werden nur Inhalte getauscht (Adressteil,
    // Positionen, Summe) — ein kompletter Neuaufbau liess die Seite bei jedem Wechsel springen.

    // Versand oder Abholung
    var versandCfg = window.CG_SHIPPING || {};
    var fV = h('div', 'sc-kasse__feld');
    fV.appendChild(h('span', 'sc-label', 'Lieferung'));
    var wahl = h('div', 'sc-kasse__wahl');
    var arten = [['standard', versandCfg.flatLabel || 'Versand']];
    if (versandCfg.pickupEnabled !== false) { arten.push(['pickup', versandCfg.pickupLabel || 'Abholung']); }
    arten.forEach(function (art) {
      var l = h('label');
      var r = h('input');
      r.type = 'radio'; r.name = 'sc-kasse-versand'; r.value = art[0];
      r.checked = kasse.versand === art[0];
      // Bei Abholung entfaellt die Adresswahl — nur der Adressteil wird neu gezeichnet.
      r.addEventListener('change', function () { if (r.checked) { kasse.versand = art[0]; kasseNeuZeichnen(); } });
      l.appendChild(r);
      l.appendChild(h('span', null, art[1]));
      wahl.appendChild(l);
    });
    fV.appendChild(wahl);
    box.appendChild(fV);

    // Lieferadresse: Karten zum Antippen statt Auswahlliste, dazu „Andere Lieferadresse".
    var adressTeil = h('div', 'sc-kasse__adressteil');
    adressTeil.id = 'sc-kasse-adressteil';
    if (kasse.versand !== 'pickup') { adressTeil.appendChild(adressWahl()); }
    box.appendChild(adressTeil);

    // Bestellnummer und Kommission (gehen in den Abacus-Kommentar)
    var zwei = h('div', 'sc-kasse__zwei');
    [['sc-kasse-po', 'Deine Bestellnummer', 25], ['sc-kasse-kom', 'Kommission', 30]].forEach(function (f) {
      var w = h('div', 'sc-kasse__feld');
      var l = h('label', 'sc-label', f[1] + ' (optional)');
      l.setAttribute('for', f[0]);
      var i = h('input');
      i.type = 'text'; i.id = f[0]; i.maxLength = f[2]; i.autocomplete = 'off';
      // Nur der Kommentar aendert sich — die Preise nicht. Trotzdem neu holen: bestellt wird
      // genau das Payload der Uebersicht, und das enthaelt diese Felder.
      i.addEventListener('input', function () { vorschauHolen(500); });
      w.appendChild(l);
      w.appendChild(i);
      zwei.appendChild(w);
    });
    box.appendChild(zwei);

    // Deine Bestellung — mit PLATZHALTERN in der Hoehe der echten Zeilen, damit beim Eintreffen
    // der Preise nichts verrutscht.
    box.appendChild(h('div', 'sc-kasse__teil', 'Deine Bestellung · ' + kassePositionen().length + ' Artikel'
      + (kasseQuelle === 'korb' ? ' aus dem Warenkorb' : '')));
    var pos = h('div', 'sc-kasse__pos');
    kassePositionen().forEach(function (p) {
      var suq = p.suq > 1 ? p.suq : 1;
      var z = posZeile(p.img, p.title || p.sku, p.sku + (p.vt ? ' · ' + p.vt : ''),
        p.menge + (suq > 1 ? ' VPE à ' + zahlCh(suq) + ' ' + einheitKurz(p.sub) + ' = ' + zahlCh(p.menge * suq) + ' ' + einheitKurz(p.sub) : ' ' + einheitKurz(p.sub)),
        'CHF …');
      z.classList.add('ist-skelett');
      pos.appendChild(z);
    });
    box.appendChild(pos);
    var sum = h('div', 'sc-kasse__summe');
    sum.appendChild(abZeile('Zwischensumme', null, 'CHF …'));
    sum.appendChild(abZeile('Versand', null, '…'));
    sum.appendChild(abZeile('Total exkl. MWST', null, 'CHF …', 'sc-ab-total'));
    box.appendChild(sum);
    var note = h('p', 'sc-panel__hinweis sc-kasse__note');
    note.style.display = 'none';
    box.appendChild(note);
    var fehler = h('p', 'sc-panel__fehler');
    fehler.style.display = 'none';
    box.appendChild(fehler);

    var fuss = h('div', 'sc-panel__fuss sc-kasse__fuss');
    var knopf = h('button', 'sc-knopf sc-knopf--rot', abnahme() ? 'Zahlungspflichtig bestellen (in der Abnahme gesperrt)' : 'Zahlungspflichtig bestellen');
    knopf.type = 'button';
    knopf.id = 'sc-kasse-bestellen';
    knopf.disabled = true;
    knopf.addEventListener('click', bestellen);
    fuss.appendChild(knopf);
    box.appendChild(fuss);
  }

  /**
   * Nur den ADRESSTEIL neu zeichnen (Adresse oder Lieferart gewechselt, Adressen nachgeladen) —
   * Eingaben der Felder „Andere Lieferadresse" bleiben erhalten. Dann Uebersicht neu holen.
   */
  function kasseNeuZeichnen() {
    var teil = $('sc-kasse-adressteil');
    if (!teil) { return; }
    var ids = ['sc-neu-firma', 'sc-neu-strasse', 'sc-neu-plz', 'sc-neu-ort'];
    var werte = {};
    ids.forEach(function (id) { var f = $(id); if (f) { werte[id] = f.value; } });
    teil.innerHTML = '';
    if (kasse.versand !== 'pickup') { teil.appendChild(adressWahl()); }
    ids.forEach(function (id) { var f = $(id); if (f && werte[id] != null) { f.value = werte[id]; } });
    vorschauHolen();
  }

  /**
   * Lieferadressen als Karten (ganze Flaeche antippbar) plus „Andere Lieferadresse" mit vier
   * Feldern. Ohne gespeicherte Adresse gilt die Standardadresse des Kontos (adresseId null).
   */
  function adressWahl() {
    var f = h('div', 'sc-kasse__feld');
    f.appendChild(h('span', 'sc-label', 'Lieferadresse'));
    var liste_ = h('div', 'sc-adressen');

    function karte(id, zeile1, zeile2) {
      var l = h('label', 'sc-adresse');
      var r = h('input');
      r.type = 'radio'; r.name = 'sc-kasse-adresse'; r.value = String(id);
      r.checked = kasse.adresseId === id;
      r.addEventListener('change', function () { if (r.checked) { kasse.adresseId = id; kasseNeuZeichnen(); } });
      l.appendChild(r);
      var t = h('span', 'sc-adresse__text');
      t.appendChild(h('b', null, zeile1));
      if (zeile2) { t.appendChild(h('span', null, zeile2)); }
      l.appendChild(t);
      liste_.appendChild(l);
    }

    if (kasse.adressen.length) {
      kasse.adressen.forEach(function (a) {
        karte(a.id, a.company || a.address1, [a.company ? a.address1 : '', [a.zip, a.city].filter(Boolean).join(' ')].filter(Boolean).join(', ')
          + (a.isDefault ? ' · Standard' : ''));
      });
    } else {
      karte(null, abnahme() ? 'Standardadresse des Testkunden' : 'Standardadresse aus deinem Konto', null);
    }
    if (!abnahme()) { karte('neu', 'Andere Lieferadresse', 'nur für diese Bestellung, innerhalb der Schweiz'); }
    f.appendChild(liste_);

    if (kasse.adresseId === 'neu') {
      var neu = h('div', 'sc-neu');
      [['sc-neu-firma', 'Firma (optional)', 60, 'organization'], ['sc-neu-strasse', 'Strasse und Nr.', 80, 'address-line1'],
       ['sc-neu-plz', 'PLZ', 4, 'postal-code'], ['sc-neu-ort', 'Ort', 50, 'address-level2']].forEach(function (d) {
        var i = h('input');
        i.type = 'text'; i.id = d[0]; i.placeholder = d[1]; i.maxLength = d[2]; i.autocomplete = d[3];
        i.setAttribute('aria-label', d[1]);
        if (d[0] === 'sc-neu-plz') { i.inputMode = 'numeric'; }
        i.addEventListener('input', function () { vorschauHolen(600); });
        neu.appendChild(i);
      });
      f.appendChild(neu);
    }
    return f;
  }

  /** Positionen, Summe und Hinweis IN den vorhandenen Behaeltern ersetzen — kein Umbau. */
  function uebersichtZeichnen(d) {
    var box = el.kasse;
    var fehler = box.querySelector('.sc-panel__fehler');
    if (fehler) { fehler.style.display = 'none'; }

    // Je Position: Bild, Titel, Nummer und KLAR die Menge — „3 VPE à 500 Stk = 1'500 Stk",
    // darunter der Preis je VPE; rechts der Zeilenbetrag. Menge und Preise vom Server.
    var pos = box.querySelector('.sc-kasse__pos');
    var neuePos = document.createDocumentFragment();
    (d.lines || []).forEach(function (ln) {
      var p = null;
      kassePositionen().forEach(function (x) { if (x.sku.toLowerCase() === String(ln.sku || '').toLowerCase()) { p = x; } });
      var suq = p && p.suq > 1 ? p.suq : 1;
      var eh = einheitKurz(p ? p.sub : '');
      var menge = ln.quantity + (suq > 1 ? ' VPE à ' + zahlCh(suq) + ' ' + eh + ' = ' + zahlCh(ln.quantity * suq) + ' ' + eh : ' ' + eh);
      if (ln.unit_price != null) { menge += ' · CHF ' + geld(ln.unit_price) + (suq > 1 ? ' je VPE' : ' je ' + eh); }
      neuePos.appendChild(posZeile(p && p.img, (p && p.title) || ln.sku || ('Variante ' + ln.variant_id),
        (ln.sku || '') + (p && p.vt ? ' · ' + p.vt : ''), menge,
        ln.line_total != null ? 'CHF ' + geld(ln.line_total) : '–'));
    });
    pos.innerHTML = '';
    pos.appendChild(neuePos);
    var teil = box.querySelector('.sc-kasse__teil');
    if (teil) { teil.textContent = 'Deine Bestellung · ' + (d.lines || []).length + ' Artikel'; }

    var sum = box.querySelector('.sc-kasse__summe');
    sum.innerHTML = '';
    sum.appendChild(abZeile('Zwischensumme', null, 'CHF ' + geld(d.subtotal)));
    var versandText;
    if (kasse.versand === 'pickup') { versandText = 'Abholung · CHF 0.00'; }
    else if (d.shipping_mode === 'separate') { versandText = 'wird separat verrechnet'; }
    else if (d.shipping_mode === 'free') { versandText = 'kostenlos'; }
    else { versandText = d.shipping ? 'CHF ' + geld(d.shipping.price) : 'CHF 0.00'; }
    sum.appendChild(abZeile('Versand', null, versandText));
    sum.appendChild(abZeile('Total exkl. MWST', null, 'CHF ' + geld(d.total), 'sc-ab-total'));

    var noten = [];
    if (d.missing_skus && d.missing_skus.length) { noten.push('Nicht bestellbar und darum nicht enthalten: ' + d.missing_skus.join(', ') + '.'); }
    if (d.prices_complete === false) { noten.push('Für einzelne Positionen fehlt ein verbindlicher Preis — unser Innendienst prüft ihn vor dem Versand.'); }
    if (abnahme()) { noten.push('Abnahme: Preise und Versand sind echt (Konditionen des Testkunden). Bestellt wird hier nichts.'); }
    var note = box.querySelector('.sc-kasse__note');
    note.textContent = noten.join(' ');
    note.style.display = noten.length ? '' : 'none';
  }

  function kasseKnopf() {
    var k = $('sc-kasse-bestellen');
    if (!k) { return; }
    k.disabled = abnahme() || !kasse.payload || kasse.sendet;
    if (!kasse.sendet) { k.textContent = abnahme() ? 'Zahlungspflichtig bestellen (in der Abnahme gesperrt)' : 'Zahlungspflichtig bestellen'; }
  }

  /** Fehler an seinem festen Platz ueber dem Bestellknopf zeigen. */
  function kasseFehler(text) {
    var f = el.kasse.querySelector('.sc-panel__fehler');
    if (f) { f.textContent = text; f.style.display = ''; }
    kasseKnopf();
  }

  function bestellen() {
    if (!kasse.payload || kasse.sendet || abnahme()) { return; }
    var s = session();
    if (!s || !s.token) { kasseFehler('Deine Anmeldung ist abgelaufen. Bitte melde dich neu an — die Liste bleibt.'); return; }
    kasse.sendet = true;
    var k = $('sc-kasse-bestellen');
    k.disabled = true;
    k.textContent = 'Bestellung wird übermittelt …';
    var payload = kasse.payload;   // ⚠️ genau das, was die Uebersicht gezeigt hat
    fetch(cfg().basis + '/api/b2b/create-invoice-order', { method: 'POST', headers: kasseKopf(s), body: JSON.stringify(payload) })
      .then(function (r) { return r.json().catch(function () { return {}; }); })
      .then(function (d) {
        kasse.sendet = false;
        if (d.status !== 'invoice_pending') {
          kasseFehler(d.code === 'session_expired'
            ? 'Deine Anmeldung ist abgelaufen. Bitte melde dich neu an — die Liste bleibt.'
            : (d.error || 'Die Bestellung ging nicht durch. Bitte versuche es erneut oder ruf unseren Innendienst an.'));
          return;
        }
        // Erfolg: nur die bestellten Artikel verlassen die Liste (alles, was im Payload stand).
        // ⚠️ ZUERST die Kasse schliessen — sonst holt zeichnen() eine neue Uebersicht und
        // ueberschreibt die Erfolgsmeldung.
        kasse.offen = false;
        var bestellt = {};
        payload.items.forEach(function (i) { bestellt[String(i.sku).toLowerCase()] = true; });
        if (kasseQuelle === 'korb') {
          // ⚠️⚠️ Aus dem Warenkorb bestellt: dieselben Mengen auch aus dem SHOP-Warenkorb abziehen —
          // sonst laegen sie dort weiter und koennten ein zweites Mal bestellt werden.
          var weg = imKorb.filter(function (p) { return bestellt[p.sku.toLowerCase()]; });
          imKorb = imKorb.filter(function (p) { return !bestellt[p.sku.toLowerCase()]; });
          imKorbSpeichern();
          korbAbziehen(weg).catch(function () {
            meldungMitLink('Bestellt — bitte die Produkte noch aus dem Warenkorb entfernen, sonst liegen sie dort weiter.',
              'Warenkorb ansehen', lokal('/cart'), 'hinweis');
          });
        } else {
          liste = liste.filter(function (p) { return !bestellt[p.sku.toLowerCase()]; });
          speichern();
        }
        zeichnen();
        kasseErfolg(d);
      })
      .catch(function () {
        kasse.sendet = false;
        // ⚠️ Unklar, ob sie angekommen ist — darum NICHT einfach „nochmal" anbieten, ohne das zu sagen.
        kasseFehler('Keine Antwort vom Server. Bitte prüfe unter „Meine Bestellungen", ob die Bestellung angekommen ist, bevor du erneut bestellst.');
      });
  }

  function kasseErfolg(d) {
    var box = el.kasse;
    box.innerHTML = '';
    var ok = h('div', 'sc-kasse__ok');
    ok.innerHTML = '<svg viewBox="0 0 52 52" aria-hidden="true"><circle cx="26" cy="26" r="24" fill="#16a34a"/>'
      + '<path d="M15 27l7 7 15-16" fill="none" stroke="#fff" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    ok.appendChild(h('h3', null, 'Bestellung eingegangen'));
    ok.appendChild(h('p', null, 'Danke! Du erhältst gleich eine Bestätigung per E-Mail. Die Rechnung kommt von unserem Innendienst.'
      + (d.order_id ? ' Bestellnummer intern: ' + d.order_id + '.' : '')));
    var a = h('a', 'sc-knopf sc-knopf--leer', 'Meine Bestellungen');
    a.href = lokal('/pages/konto') + '?bestellung=rechnung';
    ok.appendChild(a);
    box.appendChild(ok);
    kasse.offen = false;
    kasse.payload = null;
    hide(el.meldung);
  }

  function kasseSchliessen() {
    kasse.offen = false;
    kasse.payload = null;
    clearTimeout(kasse.uhr);
    kasse.lauf++;
    hide(el.kasse);
  }

  /**
   * Aktion 3: in eine Favoritenliste — eine NEUE oder eine BESTEHENDE eigene (seit 20.10.2026).
   * Die Sammelliste bleibt stehen — wer merkt, will oft trotzdem gleich bestellen.
   * Menge in VPE (Favoriten zaehlen Verkaufseinheiten, wie die Schnellerfassung). In eine
   * bestehende Liste ADDIEREN sich die Mengen (FavoriteRepository::importItems).
   * ⚠️ Zur Wahl stehen nur EIGENE Listen (isOwn) — Kollegenlisten sind lesbar, nicht beschreibbar;
   * der Server prueft das ohnehin (FavoritesController::import → ownList).
   */
  /**
   * Quelle der Favoritenliste: die Scanliste (Knopf „Als Favoritenliste") oder die Produkte im
   * Warenkorb (Warenkorb-Karte, „Als Favoritenliste sichern" — fuers andere Geraet).
   */
  var favQuelle = 'liste';
  function favPositionen() { return favQuelle === 'korb' ? imKorb : liste; }

  function favoritenOeffnen(quelle) {
    favQuelle = quelle === 'korb' ? 'korb' : 'liste';   // Klick-Ereignis → Scanliste
    if (!favPositionen().length) { return; }
    if (!el.favForm) { return; }
    if (favQuelle === 'korb') { el.favForm.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    var heute = new Date();
    el.favName.value = el.favName.value || ('Lager-Scan ' + heute.getDate() + '.' + (heute.getMonth() + 1) + '.' + heute.getFullYear());
    var wahl = el.favListe;
    wahl.innerHTML = '';
    var neuOpt = h('option', null, '+ Neue Liste anlegen');
    neuOpt.value = '';
    wahl.appendChild(neuOpt);
    favNameZeigen();
    fensterSchliessen('fav');
    show(el.favForm);

    var s = session();
    if (abnahme() || !s || !s.token) { el.favName.focus(); return; }
    fetch(cfg().basis + '/api/b2b/favorites', { headers: { 'X-Api-Key': cfg().key, 'Authorization': 'Bearer ' + s.token } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        ((d && d.lists) || []).filter(function (l) { return l.isOwn; }).forEach(function (l) {
          var o = h('option', null, l.name + ' (' + l.count + (l.count === 1 ? ' Artikel)' : ' Artikel)'));
          o.value = String(l.id);
          wahl.appendChild(o);
        });
      })
      .catch(function () { /* dann eben nur „Neue Liste" */ });
  }

  /** Namensfeld nur bei „Neue Liste". */
  function favNameZeigen() {
    var neu = !el.favListe.value;
    el.favNameZeile.style.display = neu ? '' : 'none';
    el.favSpeichern.textContent = neu ? 'Liste anlegen' : 'Hinzufügen';
  }

  function favoritenSpeichern() {
    var listId = parseInt(el.favListe.value, 10) || 0;
    var name = (el.favName.value || '').trim();
    var zielText = listId ? '„' + el.favListe.options[el.favListe.selectedIndex].text.replace(/ \(\d+ Artikel\)$/, '') + '"' : '„' + name + '"';
    if (!listId && !name) { el.favName.focus(); return; }
    if (abnahme()) {
      meldung('ABNAHME: Im Shop kämen jetzt ' + favPositionen().length + ' Artikel in die Favoritenliste ' + zielText + '. Hier wird nichts gespeichert.', 'hinweis');
      hide(el.favForm);
      return;
    }
    var s = session();
    if (!s || !s.token) { meldung('Bitte melde dich an — dann speichern wir die Liste in deinem Konto.', 'hinweis'); return; }

    el.favSpeichern.disabled = true;
    var ziel = listId ? { listId: listId } : { newListName: name };
    fetch(cfg().basis + '/api/b2b/favorites/import', {
      method: 'POST',
      headers: { 'X-Api-Key': cfg().key, 'Authorization': 'Bearer ' + s.token, 'Content-Type': 'application/json' },
      body: JSON.stringify(Object.assign(ziel, {
        items: favPositionen().map(function (p) {
          return {
            sku: p.sku, qty: p.menge, handle: p.handle || '', variantId: parseInt(p.id, 10) || 0,
            title: p.title || null, variantTitle: p.vt || null, imageUrl: p.img || null, category: p.cat || null,
            // Die fremde Nummer als Notiz — so findet man den Artikel spaeter unter der alten Nummer.
            note: p.eingabe ? 'Bisherige Nr. ' + p.eingabe : null
          };
        })
      }))
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (d) {
        if (!r.ok) { throw new Error(d.error || 'Die Liste wurde nicht gespeichert.'); }
        return d;
      });
    }).then(function (d) {
      hide(el.favForm);
      el.favName.value = '';
      meldungMitLink((listId
          ? 'In ' + zielText + ': ' + (d.created || 0) + ' neu, ' + (d.increased || 0) + ' Menge erhöht.'
          : 'Favoritenliste ' + zielText + ' mit ' + ((d.created || 0) + (d.increased || 0)) + ' Artikeln angelegt.')
        + (d.limitReached ? ' Nicht alles passte hinein (Listenlimit).' : ''), 'Zur Liste', lokal('/pages/wishlist'));
      if (window.Favorites && window.Favorites.load) { window.Favorites.load(); }
    }).catch(function (e) {
      meldung(e.message || 'Die Liste wurde nicht gespeichert.', 'fehler');
    }).then(function () { el.favSpeichern.disabled = false; });
  }

  // ── Aktion 4: Preisvergleich DIREKT auf der Scan-Seite ─────────────────────
  //
  // ⭐ 20.10.2026: Je gescannter fremder Nummer zwei Zahlen, beide vom Server:
  //   bisher   Listenpreis des Mitbewerbers je Stueck (gescrapt, hoechstens 60 Tage alt,
  //            mit Stand-Datum) — aus /api/b2b/finder/resolve, Feld ihr_preis (RAPPEN!)
  //   bei uns  DEIN Preis (Kundenkonditionen aus /api/b2b/customer-prices), ohne Anmeldung
  //            unser Listenpreis — und so beschriftet
  // Daraus nur die Multiplikation mit der gescannten Menge, nachrechenbar auf dem Schirm.
  // ⚠️ Kein Mitbewerbername (gleiche Regel wie im Artikelfinder). ⚠️ Weicht die Einheit ab
  // (Meter gegen Stueck), wird NICHT hochgerechnet — nur beide Preise gezeigt.

  function vergleichen() {
    var fremd = liste.filter(function (p) { return p.eingabe; });
    if (!fremd.length) { return; }
    fensterSchliessen('vergleich');
    var box = el.vergleichBox;
    box.innerHTML = '';
    panelKopf(box, 'Preisvergleich', function () { hide(box); });
    box.appendChild(h('div', 'sc-panel__laed', 'Preise werden geholt …'));
    show(box);
    box.scrollIntoView({ behavior: 'smooth', block: 'start' });

    var form = new URLSearchParams();
    fremd.forEach(function (p, i) { form.append('zeilen[' + i + '][i]', String(i)); form.append('zeilen[' + i + '][nr]', p.eingabe); });
    var aufloesen = fetch(cfg().basis + '/api/b2b/finder/resolve', {
      method: 'POST', headers: { 'X-Api-Key': cfg().key, 'Content-Type': 'application/x-www-form-urlencoded' }, body: form
    }).then(function (r) { if (!r.ok) { throw new Error('Vergleich gerade nicht erreichbar.'); } return r.json(); });

    var s = session();
    var a = abnahme();
    var email = a ? a.email : (s && s.email);
    var preise;
    if (a && a.email && a.rechnungUrl) {
      // ⚠️⚠️ ABNAHME (20.10.2026): Die Dashboard-Seite hat die fetch-Huelle aus theme.liquid
      // NICHT, schickt also kein Login-Token mit — und mit B2B_PRICES_TOKEN_MODE=listenpreis
      // liefert customer-prices dann nur Listenpreise (Protokoll app_order_identity_checks).
      // Darum hier derselbe Dashboard-Endpunkt wie die Kasse: unit_price je Zeile ist der
      // Kundenpreis je VPE des Testkunden (DraftOrderBuilder), ohne Bestellung.
      preise = fetch(a.rechnungUrl, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': a.csrf || '' },
        body: JSON.stringify({ items: fremd.map(function (p) { return { sku: p.sku, variant_id: parseInt(p.id, 10) || 0, quantity: 1 }; }) })
      }).then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
        var aus = {};
        ((d && d.lines) || []).forEach(function (ln) { if (ln.sku && ln.unit_price != null) { aus[ln.sku] = Number(ln.unit_price); } });
        return { prices: aus };
      }).catch(function () { return null; });
    } else {
      // Im Shop haengt die fetch-Huelle (theme.liquid) das Login-Token an — damit liefert
      // customer-prices bei verifizierten Firmenkunden die Abacus-Konditionen.
      preise = email
        ? fetch(cfg().basis + '/api/b2b/customer-prices?email=' + encodeURIComponent(email)
            + fremd.map(function (p) { return '&skus[]=' + encodeURIComponent(p.sku); }).join(''), { headers: { 'X-Api-Key': cfg().key } })
            .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; })
        : Promise.resolve(null);
    }

    Promise.all([aufloesen, preise]).then(function (e) {
      vergleichZeichnen(box, fremd, e[0], (e[1] && e[1].prices) || {});
    }).catch(function (err) {
      var l = box.querySelector('.sc-panel__laed');
      if (l) { l.parentNode.removeChild(l); }
      box.appendChild(h('p', 'sc-panel__fehler', err.message || 'Vergleich gerade nicht erreichbar.'));
    });
  }

  /**
   * Die EINE Laenge in Metern aus einer Bezeichnung („… 2m stange …" → 2, „3 Meter" → 3).
   * Millimeter zaehlen nicht („35x15mm", „6.3x18mm": nach dem m folgt ein Buchstabe).
   * Mehrere verschiedene Meterangaben oder ein unplausibler Wert → null (nicht raten).
   */
  function meterAusTitel(titel) {
    var re = /(\d+(?:[.,]\d+)?)\s?m(?:eter)?(?![a-zäöüß²³])/gi;
    var gefunden = {}, m;
    while ((m = re.exec(String(titel || ''))) !== null) {
      gefunden[parseFloat(m[1].replace(',', '.'))] = true;
    }
    var werte = Object.keys(gefunden).map(Number).filter(function (n) { return n >= 0.1 && n <= 100; });
    return werte.length === 1 ? werte[0] : null;
  }

  function einheitVergleich(e) {
    var t = String(e || '').toLowerCase();
    if (!t || t === 'stück' || t === 'stueck' || t === 'stk' || t === 'stk.') { return 'Stk'; }
    if (t === 'meter' || t === 'm') { return 'm'; }
    return t;
  }

  var RABATT_KEY = 'etikett_rabatt_mitbewerber';

  /**
   * ⭐ Zweiter Durchgang (20.10.2026, „mobil uebersichtlicher, Rabatt beim Wettbewerber"):
   *   1. Rabattfeld oben — der eigene Rabatt beim bisherigen Lieferanten (0–95 %, gemerkt).
   *      Er wirkt NUR auf dessen Listenpreis und rechnet sofort, ohne neue Anfrage.
   *   2. Summenkarte direkt darunter — die Antwort auf „lohnt sich das?" zuerst.
   *   3. Je Artikel eine Karte: Titel, „Deine Nr. → unsere Nr.", zwei Preise je Stueck
   *      nebeneinander, darunter die Menge mit beiden Betraegen.
   */
  function vergleichZeichnen(box, fremd, aufgeloest, kundenpreise) {
    var l = box.querySelector('.sc-panel__laed');
    if (l) { l.parentNode.removeChild(l); }
    var nachI = {};
    (aufgeloest.zeilen || []).forEach(function (z) { nachI[z.i] = z; });

    // Die Zahlen EINMAL zusammenstellen; das Rabattfeld rechnet nur neu.
    var kundenpreisDa = false;
    var daten = fremd.map(function (p, i) {
      var z = nachI[i] || {};
      var t = null;
      (z.treffer || []).forEach(function (x) { if (!t && String(x.sku).toLowerCase() === p.sku.toLowerCase()) { t = x; } });
      t = t || (z.treffer || [])[0] || {};
      var suq = p.suq && p.suq > 0 ? p.suq : 1;
      var kp = kundenpreise[p.sku];
      if (kp != null) { kundenpreisDa = true; }
      var vpePreis = kp != null ? Number(kp) : (t.pack ? Number(t.pack) / 100 : null);
      // ⚠️⚠️ ihr_preis kommt in RAPPEN (CompetitorSkuRepository: preis_rappen), genau wie
      // `pack`. Bis 20.10.2026 stand hier kein /100 — der Mitbewerber erschien 100-fach zu
      // teuer (V60SCSPO21B116BX: 1289 Rp. = CHF 12.89, angezeigt als CHF 1'289).
      var ihrListe = t.ihr_preis != null ? Number(t.ihr_preis) / 100 : null;
      var ehUns = einheitKurz(p.sub);
      var ehIhr = einheitVergleich(t.ihre_vpe_einheit);
      // ⭐ Meterware gegen Stangen (20.10.2026, P10MSCO35N15GS: bei uns 10 m je VPE, dort
      // „2m stange" zu CHF 12.77 je Stueck): Steht in der Bezeichnung GENAU EINE Meterangabe,
      // wird auf Meter umgerechnet — offen ausgewiesen. Sonst bleibt es bei „andere Einheit".
      var umrechnung = null;
      if (ihrListe != null && ehUns === 'm' && ehIhr === 'Stk') {
        var laenge = meterAusTitel(t.ihr_titel);
        if (laenge) {
          ihrListe = ihrListe / laenge;
          ehIhr = 'm';
          umrechnung = 'umgerechnet: 1 Stück = ' + zahlCh(laenge) + ' m (laut Bezeichnung)';
        }
      }
      return {
        p: p, suq: suq, kunde: kp != null,
        unsStk: vpePreis != null ? vpePreis / suq : null,
        ihrListe: ihrListe, umrechnung: umrechnung,
        stand: t.ihr_preis_stand || null,
        ehUns: ehUns, ehIhr: ehIhr
      };
    });

    // 1. Rabattfeld
    var rabattBox = h('div', 'sc-vg__rabatt');
    var rl = h('label', null, 'Dein Rabatt beim bisherigen Lieferanten');
    rl.setAttribute('for', 'sc-vg-rabatt');
    rabattBox.appendChild(rl);
    var rw = h('div', 'sc-vg__rabatt-feld');
    var minus = h('button', null, '−'); minus.type = 'button'; minus.setAttribute('aria-label', '5 % weniger');
    var feld = h('input');
    feld.type = 'number'; feld.id = 'sc-vg-rabatt'; feld.min = '0'; feld.max = '95'; feld.step = '1'; feld.inputMode = 'decimal';
    var gemerkt = 0;
    try { gemerkt = parseFloat(localStorage.getItem(RABATT_KEY) || '0') || 0; } catch (e) { gemerkt = 0; }
    feld.value = String(gemerkt);
    var plus = h('button', null, '+'); plus.type = 'button'; plus.setAttribute('aria-label', '5 % mehr');
    rw.appendChild(minus); rw.appendChild(feld); rw.appendChild(h('span', null, '%')); rw.appendChild(plus);
    rabattBox.appendChild(rw);
    box.appendChild(rabattBox);

    // Bezugsmenge fuer die Karten: deine Menge (Vorgabe), je 1'000 oder je 1 Einheit.
    var BEZUG_KEY = 'etikett_vergleich_bezug';
    var bezug = 'menge';
    try { bezug = localStorage.getItem(BEZUG_KEY) || 'menge'; } catch (e) { bezug = 'menge'; }
    if (['menge', '1000', '1'].indexOf(bezug) === -1) { bezug = 'menge'; }
    var bz = h('div', 'sc-vg__bezug');
    bz.setAttribute('role', 'group');
    bz.setAttribute('aria-label', 'Vergleichen für');
    var knoepfe = [];
    [['menge', 'Deine Menge'], ['1000', "je 1'000"], ['1', 'je 1']].forEach(function (w) {
      var b = h('button', null, w[1]);
      b.type = 'button';
      b.setAttribute('aria-pressed', bezug === w[0] ? 'true' : 'false');
      b.addEventListener('click', function () {
        bezug = w[0];
        try { localStorage.setItem(BEZUG_KEY, bezug); } catch (e) { /* egal */ }
        knoepfe.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        rechnen();
      });
      knoepfe.push(b);
      bz.appendChild(b);
    });
    box.appendChild(bz);

    var inhalt = h('div', 'sc-vg__inhalt');
    box.appendChild(inhalt);

    function rabatt() { return Math.max(0, Math.min(95, parseFloat(String(feld.value).replace(',', '.')) || 0)); }
    function setze(n) { feld.value = String(Math.max(0, Math.min(95, n))); rechnen(); }
    minus.addEventListener('click', function () { setze(rabatt() - 5); });
    plus.addEventListener('click', function () { setze(rabatt() + 5); });
    feld.addEventListener('input', rechnen);

    function rechnen() {
      var r = rabatt();
      try { localStorage.setItem(RABATT_KEY, String(r)); } catch (e) { /* egal */ }
      inhalt.innerHTML = '';
      var bisherSumme = 0, unsSumme = 0, gerechnet = 0, guenstiger = 0, mitPreis = 0;
      var karten = [];

      daten.forEach(function (d) {
        var ihrStk = d.ihrListe != null ? d.ihrListe * (1 - r / 100) : null;
        var gleich = d.ehIhr === d.ehUns;
        // ⚠️ Plausibilitaetsbremse: mehr als Faktor 10 Unterschied je Stueck ist fast immer ein
        // Datenfehler (Boxpreis gegen Stueckpreis, falsche VPE) — nicht in Ersparnis und Summe.
        var plausibel = ihrStk != null && d.unsStk != null && d.unsStk > 0 && ihrStk > 0
          && ihrStk / d.unsStk <= 10 && d.unsStk / ihrStk <= 10;
        var vergleichbar = ihrStk != null && d.unsStk != null && gleich && plausibel;
        var billiger = vergleichbar && d.unsStk < ihrStk;
        if (ihrStk != null) { mitPreis++; }
        if (billiger) { guenstiger++; }

        // ⭐ GLEICHE MENGE auf beiden Seiten (dritter Durchgang 20.10.2026): Hauptzahl ist der
        // Betrag fuer genau diese Stueckzahl — „was zahlte ich dort fuer dieselben 10'000 Stk?".
        // Die Summenkarte rechnet IMMER mit deinen gescannten Mengen, egal was oben gewaehlt ist.
        var deine = d.p.menge * d.suq;
        var n = bezug === 'menge' ? deine : Number(bezug);
        if (vergleichbar) { bisherSumme += ihrStk * deine; unsSumme += d.unsStk * deine; gerechnet++; }

        var k = h('div', 'sc-vg' + (billiger ? ' ist-guenstiger' : ''));
        k.appendChild(h('div', 'sc-vg__titel', d.p.title || d.p.sku));
        var nr = h('div', 'sc-vg__nr', 'Deine Nr. ' + d.p.eingabe + '  →  ' + d.p.sku);
        if (d.p.art === 'gleichwertig' || d.p.art === 'alternative') {
          nr.appendChild(h('span', 'sc-zeile__art', d.p.art === 'gleichwertig' ? 'gleichwertig' : 'Alternative'));
        }
        k.appendChild(nr);

        k.appendChild(h('div', 'sc-vg__fuer', gleich ? 'Für ' + zahlCh(n) + ' ' + d.ehUns + (bezug === 'menge' ? ' (deine Menge)' : '') : 'Preis je Einheit'));
        var preise = h('div', 'sc-vg__preise');
        var bisher = h('div', 'sc-vg__preis');
        bisher.appendChild(h('small', null, 'Bisher'));
        bisher.appendChild(h('b', null, ihrStk == null ? '–' : (gleich ? 'CHF ' + geld(ihrStk * n) : 'CHF ' + stueckpreis(ihrStk))));
        bisher.appendChild(h('span', null, ihrStk != null
          ? 'CHF ' + stueckpreis(ihrStk) + ' / ' + d.ehIhr + (r ? ' · −' + zahlCh(r) + ' %' : ' · Liste')
          : 'kein Preis bekannt'));
        var wir = h('div', 'sc-vg__preis sc-vg__preis--wir' + (billiger ? ' ist-guenstiger' : ''));
        wir.appendChild(h('small', null, 'Bei uns'));
        wir.appendChild(h('b', null, d.unsStk == null ? '–' : (gleich ? 'CHF ' + geld(d.unsStk * n) : 'CHF ' + stueckpreis(d.unsStk))));
        wir.appendChild(h('span', null, d.unsStk != null ? 'CHF ' + stueckpreis(d.unsStk) + ' / ' + d.ehUns + ' · ' + (d.kunde ? 'dein Preis' : 'Liste') : ''));
        preise.appendChild(bisher);
        preise.appendChild(wir);
        k.appendChild(preise);
        if (d.umrechnung) { k.appendChild(h('div', 'sc-vg__um', d.umrechnung)); }

        if (vergleichbar) {
          var diff = (ihrStk - d.unsStk) * n;
          var prozent = ihrStk > 0 ? Math.round((ihrStk - d.unsStk) / ihrStk * 100) : 0;
          k.appendChild(h('div', 'sc-vg__diff' + (diff > 0 ? ' ist-guenstiger' : (diff < 0 ? ' ist-teurer' : '')),
            diff > 0 ? 'Du sparst CHF ' + geld(diff) + ' (' + prozent + ' %)'
              : (diff < 0 ? 'Bei uns CHF ' + geld(-diff) + ' teurer (' + Math.abs(prozent) + ' %)' : 'Gleich teuer')));
        } else if (ihrStk != null && d.unsStk != null && !gleich) {
          k.appendChild(h('div', 'sc-vg__diff', 'Andere Einheit (' + d.ehIhr + ' / ' + d.ehUns + ') — bitte selbst vergleichen'));
        } else if (ihrStk != null && d.unsStk != null) {
          k.appendChild(h('div', 'sc-vg__diff', 'Preise weichen stark ab — vermutlich andere Packungsgrösse. Nicht in der Summe; wir prüfen das.'));
        }
        karten.push(k);
      });

      // 2. Summe zuerst
      if (gerechnet) {
        var diff = bisherSumme - unsSumme;
        var s = h('div', 'sc-vg__summe' + (diff > 0 ? ' ist-guenstiger' : ''));
        s.appendChild(h('small', null, 'Für deine gescannten Mengen' + (gerechnet < daten.length ? ' · ' + gerechnet + ' von ' + daten.length + ' Artikeln' : '')));
        s.appendChild(h('b', null, diff > 0 ? 'Du sparst CHF ' + geld(diff) : (diff < 0 ? 'Bei uns CHF ' + geld(-diff) + ' teurer' : 'Gleich teuer')));
        s.appendChild(h('span', null, 'bisher CHF ' + geld(bisherSumme) + '  →  bei uns CHF ' + geld(unsSumme)));
        if (mitPreis) { s.appendChild(h('span', null, guenstiger + ' von ' + mitPreis + ' Artikeln bei uns günstiger')); }
        inhalt.appendChild(s);
      } else if (!mitPreis) {
        inhalt.appendChild(h('p', 'sc-panel__hinweis', 'Zu diesen Nummern kennen wir noch keinen aktuellen Preis des bisherigen Lieferanten.'));
      }
      karten.forEach(function (k) { inhalt.appendChild(k); });

      inhalt.appendChild(h('p', 'sc-panel__hinweis', (kundenpreisDa
        ? 'Bei uns: deine Konditionen, exkl. MWST. '
        : 'Bei uns: Listenpreis exkl. MWST — angemeldet siehst du deine Konditionen. ')
        + 'Bisher: Listenpreis des bisherigen Lieferanten je Stück'
        + (r ? ', abzüglich deiner ' + zahlCh(r) + ' % Rabatt.' : ' — trage oben deinen Rabatt dort ein, dann wird es genau.')));
    }
    rechnen();

    var fuss = h('div', 'sc-panel__fuss');
    if (document.documentElement.classList.contains('b2b-invoice-eligible')) {
      var kauf = h('button', 'sc-knopf sc-knopf--rot', 'Jetzt auf Rechnung kaufen');
      kauf.type = 'button';
      kauf.addEventListener('click', sofortKaufen);
      fuss.appendChild(kauf);
    }
    box.appendChild(fuss);
  }

  /** "2026-10-12" → "12.10.2026" */
  function datumCh(iso) {
    var t = String(iso || '').split('-');
    return t.length === 3 ? t[2].slice(0, 2) + '.' + t[1] + '.' + t[0] : String(iso || '');
  }

  // ── Kamera ────────────────────────────────────────────────────────────────

  // ── Strichcode-Leser Code128 (fuer das iPhone) ──────────────────────────────
  //
  // ⭐ 20.10.2026: Safari hat keinen BarcodeDetector, und jsQR liest NUR QR — am iPhone
  // wurde der Strichcode deshalb nie erkannt. Dieser Leser ist das Gegenstueck zu
  // src/Service/B2b/Code128.php: dieselbe Mustertabelle, dieselbe Pruefziffer.
  //
  // Ablauf je Bildzeile: Helligkeit → lokale Schwelle (Mitte aus Min/Max der Umgebung,
  // robust gegen Schatten und Verlauf) → Strich-/Lueckenbreiten → Startzeichen suchen →
  // Zeichen fuer Zeichen gegen die Tabelle (Abweichungsmass wie ZXing) → Stoppzeichen →
  // Pruefziffer. Liest Zeichensatz A/B/C, also auch fremde Code128-Etiketten.
  //
  // ⚠️ Fehllesungen: Die Pruefziffer (mod 103) faengt fast alles ab. Zusaetzlich zaehlt ein
  // Treffer erst, wenn ZWEI Bildzeilen dasselbe lesen — oder dieselbe Zeile in zwei Bildern
  // kurz nacheinander (siehe leserBauen).

  var C128 = [
    '212222', '222122', '222221', '121223', '121322', '131222', '122213', '122312', '132212', '221213',
    '221312', '231212', '112232', '122132', '122231', '113222', '123122', '123221', '223211', '221132',
    '221231', '213212', '223112', '312131', '311222', '321122', '321221', '312212', '322112', '322211',
    '212123', '212321', '232121', '111323', '131123', '131321', '112313', '132113', '132311', '211313',
    '231113', '231311', '112133', '112331', '132131', '113123', '113321', '133121', '313121', '211331',
    '231131', '213113', '213311', '213131', '311123', '311321', '331121', '312113', '312311', '332111',
    '314111', '221411', '431111', '111224', '111422', '121124', '121421', '141122', '141221', '112214',
    '112412', '122114', '122411', '142112', '142211', '241211', '221114', '413111', '241112', '134111',
    '111242', '121142', '121241', '114212', '124112', '124211', '411212', '421112', '421211', '212141',
    '214121', '412121', '111143', '111341', '131141', '114113', '114311', '411113', '411311', '113141',
    '114131', '311141', '411131', '211412', '211214', '211232', '2331112'
  ].map(function (s) { return s.split('').map(Number); });
  var C128_STOPP = 106;
  var MAX_ABW = 0.25;        // mittlere Abweichung je Modul (ZXing: MAX_AVG_VARIANCE)
  var MAX_ABW_EINZELN = 0.7; // ein einzelner Strich darf hoechstens so weit danebenliegen

  /** Wie gut passen die Laeufe ab `i` zum Muster? 0 = perfekt, Infinity = gar nicht. */
  function abweichung(laeufe, i, muster, module) {
    var summe = 0, k;
    for (k = 0; k < muster.length; k++) { summe += laeufe[i + k]; }
    var einheit = summe / module;
    var gesamt = 0;
    for (k = 0; k < muster.length; k++) {
      var d = Math.abs(laeufe[i + k] - muster[k] * einheit);
      if (d > MAX_ABW_EINZELN * einheit) { return Infinity; }
      gesamt += d;
    }
    return gesamt / summe;
  }

  /** @param nurStart  nur die drei Startzeichen 103–105 pruefen (Suche nach dem Anfang) */
  function zeichenLesen(laeufe, i, nurStart) {
    if (i + 6 > laeufe.length) { return null; }
    var summe = 0;
    for (var k = 0; k < 6; k++) { summe += laeufe[i + k]; }
    var best = -1, bestAbw = MAX_ABW;
    for (var v = nurStart ? 103 : 0; v < (nurStart ? 106 : C128_STOPP); v++) {
      var a = abweichung(laeufe, i, C128[v], 11);
      if (a < bestAbw) { bestAbw = a; best = v; }
    }
    return best < 0 ? null : { wert: best, abw: bestAbw, summe: summe };
  }

  /** Symbolwerte → Text (Zeichensatz A/B/C mit Umschaltungen); null bei falscher Pruefziffer. */
  function c128Text(werte) {
    var n = werte.length;
    var pruef = werte[0];
    for (var i = 1; i < n - 1; i++) { pruef += werte[i] * i; }
    if (pruef % 103 !== werte[n - 1]) { return null; }

    var satz = werte[0] === 103 ? 'A' : (werte[0] === 104 ? 'B' : 'C');
    var aus = '', einmal = false;
    for (var j = 1; j < n - 1; j++) {
      var v = werte[j];
      var s = einmal ? (satz === 'A' ? 'B' : 'A') : satz;
      einmal = false;
      if (s === 'C') {
        if (v < 100) { aus += (v < 10 ? '0' : '') + v; }
        else if (v === 100) { satz = 'B'; }
        else if (v === 101) { satz = 'A'; }
        continue;   // 102 = FNC1: kein Zeichen
      }
      if (v === 98) { einmal = true; continue; }
      if (v === 99) { satz = 'C'; continue; }
      if (v === 100 && s === 'A') { satz = 'B'; continue; }
      if (v === 101 && s === 'B') { satz = 'A'; continue; }
      if (v >= 95) { continue; }   // FNC1–4, DEL: kein druckbares Zeichen
      if (s === 'A' && v >= 64) { continue; }   // Steuerzeichen
      aus += String.fromCharCode(v + 32);
    }
    return aus.length ? aus : null;
  }

  /**
   * In [Rand, Strich, Luecke, Strich, …] einen Code128 suchen. Striche stehen an den
   * UNGERADEN Stellen; laeufe[i - 1] ist immer die helle Flaeche vor dem Startzeichen.
   */
  function c128AusLaeufen(laeufe) {
    for (var i = 1; i + 6 + 6 + 7 <= laeufe.length; i += 2) {
      var start = zeichenLesen(laeufe, i, true);
      if (!start) { continue; }
      var modul = start.summe / 11;
      // Ruhezone links: davor muss es hell sein (Norm 10 Module, hier grosszuegig 4).
      if (laeufe[i - 1] < modul * 4) { continue; }

      var werte = [start.wert], j = i + 6, fertig = false;
      while (j + 7 <= laeufe.length) {
        var stopp = abweichung(laeufe, j, C128[C128_STOPP], 13);
        var z = zeichenLesen(laeufe, j);
        if (stopp < MAX_ABW && (!z || stopp <= z.abw)) { fertig = true; break; }
        // Gleiche Modulgroesse wie das Startzeichen — sonst ist das Rauschen, kein Code.
        if (!z || z.wert >= 103 || Math.abs(z.summe - start.summe) > start.summe * 0.35) { break; }
        werte.push(z.wert);
        j += 6;
      }
      if (!fertig || werte.length < 3) { continue; }
      var text = c128Text(werte);
      if (text) { return text; }
    }
    return null;
  }

  /** Helligkeiten einer Zeile → Laeufe, beginnend mit dem ersten dunklen. */
  function laeufeAus(g, n) {
    // Lokale Schwelle ueber Bloecke: Mitte aus Min/Max des eigenen und der Nachbarbloecke.
    var B = Math.max(8, Math.round(n / 40));
    var bloecke = Math.ceil(n / B), mins = [], maxs = [], b, x;
    for (b = 0; b < bloecke; b++) {
      var lo = 255, hi = 0;
      for (x = b * B; x < Math.min(n, (b + 1) * B); x++) { if (g[x] < lo) { lo = g[x]; } if (g[x] > hi) { hi = g[x]; } }
      mins.push(lo); maxs.push(hi);
    }
    var laeufe = [], dunkelVorher = false, lauf = 0, begonnen = false;
    for (x = 0; x < n; x++) {
      b = Math.floor(x / B);
      var mi = Math.min(mins[b], mins[Math.max(0, b - 1)], mins[Math.min(bloecke - 1, b + 1)]);
      var ma = Math.max(maxs[b], maxs[Math.max(0, b - 1)], maxs[Math.min(bloecke - 1, b + 1)]);
      var dunkel = ma - mi >= 28 && g[x] < (mi + ma) / 2;   // ohne Kontrast: hell
      if (!begonnen) {
        if (!dunkel) { continue; }
        begonnen = true; dunkelVorher = true; lauf = 1;
        laeufe.push(x);   // Platzhalter: heller Rand vor dem ersten Strich (fuer die Ruhezone)
        continue;
      }
      if (dunkel === dunkelVorher) { lauf++; } else { laeufe.push(lauf); lauf = 1; dunkelVorher = dunkel; }
    }
    if (begonnen) { laeufe.push(lauf); }
    return laeufe;   // [Rand, Strich, Luecke, Strich, …]
  }

  /** Eine Zeile vorwaerts und rueckwaerts lesen (Etikett steht auf dem Kopf). */
  function zeileLesen(g, n) {
    var l = laeufeAus(g, n);
    if (l.length < 20) { return null; }
    var t = c128AusLaeufen(l);
    if (t) { return t; }
    // Rueckwaerts: [hinterer Rand, letzter Strich, …]. Endet die Zeile hell (gerade Anzahl
    // nach dem Rand), ist der letzte Lauf der hintere Rand; endet sie dunkel, ist er 0.
    var mitte = l.slice(1);
    var hinten = mitte.length % 2 === 0 ? mitte.pop() : 0;
    return c128AusLaeufen([hinten].concat(mitte.reverse()));
  }

  /**
   * Strichcode in einem Bildausschnitt suchen: 9 waagrechte und 9 senkrechte Linien
   * (Etikett quer oder hochkant), jede ueber 3 Pixelzeilen gemittelt gegen Rauschen.
   * @return {{text: string, sicher: boolean}|null}  sicher = zwei Linien lesen dasselbe
   */
  function strichcodeLesen(bild) {
    var w = bild.width, h = bild.height, d = bild.data;
    var funde = {}, k, x, y, dy, s, idx;
    var zeile = new Float32Array(Math.max(w, h));
    for (var richtung = 0; richtung < 2; richtung++) {
      var laenge = richtung === 0 ? w : h, quer = richtung === 0 ? h : w;
      for (k = 0; k < 9; k++) {
        var p = Math.round(quer * (0.2 + k * 0.075));
        if (p < 1 || p >= quer - 1) { continue; }
        for (x = 0; x < laenge; x++) {
          s = 0;
          for (dy = -1; dy <= 1; dy++) {
            idx = richtung === 0 ? ((p + dy) * w + x) * 4 : (x * w + p + dy) * 4;
            s += d[idx] * 77 + d[idx + 1] * 150 + d[idx + 2] * 29;
          }
          zeile[x] = s / 768;
        }
        var t = zeileLesen(zeile, laenge);
        if (t) {
          funde[t] = (funde[t] || 0) + 1;
          if (funde[t] >= 2) { return { text: t, sicher: true }; }
        }
      }
    }
    var gefunden = Object.keys(funde);
    return gefunden.length === 1 ? { text: gefunden[0], sicher: false } : null;
  }

  /**
   * Ein Leser fuer Kamerabilder — gleiche Schnittstelle (Promise auf Text|null):
   *   BarcodeDetector  Chrome/Android: QR UND Strichcodes (Code128, EAN) nativ
   *   sonst (iPhone)   eigener Code128-Leser + jsQR, beide auf dem MITTELAUSSCHNITT in
   *                    voller Aufloesung (vorher: ganzes Bild auf 720 px verkleinert —
   *                    ein 18-mm-QR hatte dann nur noch 2–3 Pixel je Modul)
   */
  function leserBauen() {
    if ('BarcodeDetector' in window) {
      var erkenner;
      try { erkenner = new window.BarcodeDetector({ formats: ['qr_code', 'code_128', 'ean_13', 'ean_8', 'code_39'] }); } catch (e) {
        erkenner = new window.BarcodeDetector();
      }
      return function (video) {
        return erkenner.detect(video).then(function (c) { return c && c.length ? c[0].rawValue : null; });
      };
    }
    var leinwand = document.createElement('canvas');
    var ctx = leinwand.getContext('2d', { willReadFrequently: true });
    var takt = 0;
    var vorher = { text: '', zeit: 0 };   // unsicherer Strichcode-Treffer des letzten Bildes

    function ausschnitt(video, sx, sy, sw, sh, max) {
      var f = Math.min(1, max / Math.max(sw, sh));
      leinwand.width = Math.max(1, Math.round(sw * f));
      leinwand.height = Math.max(1, Math.round(sh * f));
      ctx.drawImage(video, sx, sy, sw, sh, 0, 0, leinwand.width, leinwand.height);
      return ctx.getImageData(0, 0, leinwand.width, leinwand.height);
    }
    function qr(bild) {
      if (typeof window.jsQR !== 'function') { return null; }
      var c = window.jsQR(bild.data, bild.width, bild.height, { inversionAttempts: 'dontInvert' });
      return c && c.data ? c.data : null;
    }
    function strich(bild) {
      var sc = strichcodeLesen(bild);
      if (!sc) { return null; }
      var jetzt = Date.now();
      if (sc.sicher || (sc.text === vorher.text && jetzt - vorher.zeit < 1500)) {
        vorher = { text: '', zeit: 0 };
        return sc.text;
      }
      vorher = { text: sc.text, zeit: jetzt };
      return null;
    }

    /*
     * ⭐ 20.10.2026 (zweiter Durchgang, „behaebig"): EIN kleiner Ausschnitt je Bild, im Wechsel.
     * Vorher liefen Strichcode-Leser UND jsQR in jedem Bild ueber bis zu 1280 px — am iPhone
     * 150–300 ms je Bild. Jetzt:
     *   gerade Bilder    Strichcode: waagrechter Streifen um die rote Linie (90 % × 24 %),
     *                    unverkleinert bis 1100 px; jedes 4. Mal stattdessen ein senkrechter
     *   ungerade Bilder  QR: Mittelquadrat, auf 640 px; jedes 6. Mal das ganze Bild auf 480 px
     *                    (QR sehr nah oder ausserhalb des Suchers)
     * Das sind rund ein Drittel der Pixel von vorher, bei gleicher Schaerfe im Sucher.
     */
    return function (video) {
      var b = video.videoWidth, h = video.videoHeight;
      if (!b || !h || video.readyState < 2) { return Promise.resolve(null); }
      takt++;
      var text = null;
      if (takt % 2 === 0) {
        text = (takt % 8 === 0)
          ? strich(ausschnitt(video, Math.round(b * 0.33), Math.round(h * 0.05), Math.round(b * 0.34), Math.round(h * 0.9), 1000))
          : strich(ausschnitt(video, Math.round(b * 0.05), Math.round(h * 0.38), Math.round(b * 0.9), Math.round(h * 0.24), 1100));
      } else if (takt % 6 === 5) {
        text = qr(ausschnitt(video, 0, 0, b, h, 480));
      } else {
        var seite = Math.round(Math.min(b, h) * 0.8);
        text = qr(ausschnitt(video, Math.round((b - seite) / 2), Math.round((h - seite) / 2), seite, seite, 640));
      }
      return Promise.resolve(text);
    };
  }

  /**
   * Kamera nachjustieren, soweit das Geraet es kann: Dauerfokus und Taschenlampe (Android).
   * Alles optional; was fehlt, wird still uebergangen.
   *
   * ⚠️ KEIN Zoom mehr (20.10.2026, „Kamera buggt"): Auf neueren iPhones schaltet Safari bei
   * zoom ≥ 1.5 zwischen den Objektiven um — das Bild springt und wird kurz unscharf.
   */
  function kameraAbstimmen(s) {
    var spur = s.getVideoTracks ? s.getVideoTracks()[0] : null;
    if (!spur || typeof spur.getCapabilities !== 'function') { return; }
    var f = {};
    try { f = spur.getCapabilities() || {}; } catch (e) { return; }
    if (f.focusMode && f.focusMode.indexOf('continuous') !== -1) {
      spur.applyConstraints({ advanced: [{ focusMode: 'continuous' }] }).catch(function () { /* egal */ });
    }
    var licht = $('sc-licht');
    if (licht) {
      licht.style.display = f.torch ? '' : 'none';
      licht.setAttribute('aria-pressed', 'false');
      licht.onclick = function () {
        var an = licht.getAttribute('aria-pressed') !== 'true';
        spur.applyConstraints({ advanced: [{ torch: an }] }).then(function () {
          licht.setAttribute('aria-pressed', an ? 'true' : 'false');
        }).catch(function () { licht.style.display = 'none'; });
      };
    }
  }

  /**
   * Selbsttest des Strichcode-Lesers — NUR in der Abnahme. Zeichnet Code128 wie das Etikett
   * (unscharf: krumme Pixelbreite, verkleinert und wieder vergroessert, einmal kopfueber)
   * und liest ihn zurueck. Zeigt, dass der Leser im Browser des Testers laeuft.
   */
  function selbsttest() {
    var proben = ['B01ASBH6', 'G90SWAP1B24/2', 'NR-5015.120', 'B01ASBH6'];
    var ok = 0;
    proben.forEach(function (text, nr) {
      var werte = [104], summe = 104;
      for (var i = 0; i < text.length; i++) { var v = text.charCodeAt(i) - 32; werte.push(v); summe += v * (i + 1); }
      werte.push(summe % 103, C128_STOPP);
      var breiten = [];
      werte.forEach(function (w) { breiten = breiten.concat(C128[w]); });
      var modul = 2.3, rand = 12 * modul;
      var gesamt = breiten.reduce(function (a, c) { return a + c; }, 0) * modul + 2 * rand;
      var c = document.createElement('canvas');
      c.width = Math.ceil(gesamt); c.height = 80;
      var x = c.getContext('2d', { willReadFrequently: true });
      x.fillStyle = '#f4f1ea'; x.fillRect(0, 0, c.width, c.height);   // Papier, nicht reinweiss
      x.fillStyle = '#1a1a1a';
      var pos = rand;
      breiten.forEach(function (bb, k) { if (k % 2 === 0) { x.fillRect(pos, 10, bb * modul, 60); } pos += bb * modul; });
      // Unschaerfe: auf 60 % verkleinern und zurueck.
      var klein = document.createElement('canvas');
      klein.width = Math.round(c.width * 0.6); klein.height = Math.round(c.height * 0.6);
      klein.getContext('2d').drawImage(c, 0, 0, klein.width, klein.height);
      x.save();
      if (nr === 3) { x.translate(c.width, c.height); x.scale(-1, -1); }   // kopfueber
      x.drawImage(klein, 0, 0, c.width, c.height);
      x.restore();
      var r = strichcodeLesen(x.getImageData(0, 0, c.width, c.height));
      if (r && r.text === text) { ok++; } else if (window.console) { console.warn('[Scan] Selbsttest', text, '→', r); }
    });
    return { ok: ok, von: proben.length };
  }

  function kameraStarten() {
    tonBereit();   // ⚠️ hier, im Klick — sonst spielt Safari den Scan-Ton nie
    var leser = leserBauen();
    if (!leser || !navigator.mediaDevices) {
      el.kameraHinweis.textContent = 'Kamera-Scan geht in diesem Browser nicht. Nimm die Kamera-App deines Telefons '
        + '(sie öffnet den QR-Code direkt hier) oder einen Handscanner.';
      show(el.kameraHinweis);
      return;
    }
    if (strom) { kameraStoppen(); return; }
    el.kameraHinweis.textContent = 'QR-Code oder Strichcode in den Rahmen halten, den Strichcode entlang der roten Linie — '
      + 'Abstand etwa 15 bis 25 cm.';
    show(el.kameraHinweis);

    // ⚠️ Aufloesung ausdruecklich anfordern: ohne Vorgabe liefert Safari oft nur 640×480.
    // Hochformat: 1920×1080 heisst 1080 px BREITE — fuer den quer liegenden Strichcode noetig
    // (bei 720 px blieben nur gut 2 Pixel je Strich). Das Tempo kostete nicht die Kamera,
    // sondern die Auswertung — die arbeitet jetzt auf kleinen Ausschnitten (leserBauen).
    navigator.mediaDevices.getUserMedia({
      video: { facingMode: { ideal: 'environment' }, width: { ideal: 1920 }, height: { ideal: 1080 } }
    }).then(function (s) {
      strom = s;
      el.video.srcObject = s;
      el.video.setAttribute('playsinline', '');   // iPhone: sonst Vollbild statt eingebettet
      el.video.muted = true;
      show(el.rahmen);   // Rahmen mit Sucher-Ecken und Treffer-Ebene, nicht nur das Video
      var spielt = el.video.play();
      if (spielt && spielt.catch) { spielt.catch(function () { /* iOS: startet mit dem naechsten Bild */ }); }
      kameraText('Kamera aus');
      kameraAbstimmen(s);

      // Takt: jedes NEUE Kamerabild genau einmal (requestVideoFrameCallback, iOS 15.4+) — nie
      // zweimal dasselbe Bild, nie ein Stau. Ohne diese Funktion alle 60 ms.
      // Nach einem Treffer 700 ms Ruhe: dasselbe Etikett steht ja noch vor der Linse.
      var ruheBis = 0;
      function weiter() {
        if (!strom) { return; }
        if (typeof el.video.requestVideoFrameCallback === 'function') { el.video.requestVideoFrameCallback(schleife); }
        else { setTimeout(schleife, 60); }
      }
      function schleife() {
        if (!strom) { return; }
        if (Date.now() < ruheBis) { weiter(); return; }
        leser(el.video).then(function (text) {
          if (text) { ruheBis = Date.now() + 700; scan(text, false); }
        }).catch(function () { /* einzelnes Bild nicht lesbar */ })
          .then(weiter);
      }
      weiter();
    }).catch(function () {
      el.kameraHinweis.textContent = 'Kein Zugriff auf die Kamera. Bitte im Browser erlauben.';
      show(el.kameraHinweis);
    });
  }

  function kameraStoppen() {
    if (strom) { strom.getTracks().forEach(function (t) { t.stop(); }); }
    strom = null;
    hide(el.rahmen);
    hide(el.kameraHinweis);
    kameraText('Kamera');
  }

  /** Nur die Beschriftung tauschen — textContent auf dem Knopf loeschte das Kamera-Symbol. */
  function kameraText(t) {
    var span = el.kamera.querySelector('span');
    (span || el.kamera).textContent = t;
  }

  // ── Start ─────────────────────────────────────────────────────────────────

  function init() {
    el.feld = $('sc-feld');
    el.kamera = $('sc-kamera');
    el.kameraHinweis = $('sc-kamera-hinweis');
    el.video = $('sc-video');
    el.rahmen = $('sc-video-rahmen') || el.video;   // aeltere Section ohne Rahmen: das Video selbst
    el.meldung = $('sc-meldung');
    el.auswahl = $('sc-auswahl');
    el.liste = $('sc-liste');
    el.anzahl = $('sc-anzahl');
    el.aktionen = $('sc-aktionen');
    el.sofort = $('sc-sofort');
    el.warenkorb = $('sc-warenkorb');
    el.favorit = $('sc-favorit');
    el.vergleich = $('sc-vergleich');
    el.leeren = $('sc-leeren');
    el.kasse = $('sc-kasse');
    el.vergleichBox = $('sc-vergleich-box');
    el.korbBox = $('sc-korb-box');
    el.korbLeiste = $('sc-korb-leiste');
    el.favListe = $('sc-fav-liste');
    el.favNameZeile = $('sc-fav-name-zeile');
    el.favForm = $('sc-fav');
    el.favName = $('sc-fav-name');
    el.favSpeichern = $('sc-fav-speichern');
    if (!el.feld || !el.liste) { return; }

    if (!cfg().key) {
      meldung('Die Scan-Seite ist gerade nicht eingerichtet.', 'fehler');
      if (window.console) { console.error('[Scan] window.b2bConfig hat keinen apiKey.'); }
      return;
    }

    // „Sofort kaufen" zeigt das CSS nur mit html.b2b-invoice-eligible — die Klasse setzt
    // checkout-gate.js, und zwar oft erst NACH diesem init (Freigabe kommt vom Server).
    // In der Abnahme gibt es checkout-gate.js nicht; dort rechnet abnahmeRechnung().
    if (abnahme()) { document.documentElement.classList.add('b2b-invoice-eligible'); }

    laden();
    imKorbLaden();
    var mengenDa = mengenLaden();
    zeichnen();
    imKorbAbgleichen();

    // Abnahme: zeigen, dass der Strichcode-Leser in DIESEM Browser laeuft.
    if (abnahme()) {
      try {
        var st = selbsttest();
        meldung('Selbsttest Strichcode-Leser: ' + st.ok + ' von ' + st.von + ' Strichcodes gelesen.', st.ok === st.von ? 'ok' : 'fehler');
      } catch (e) {
        meldung('Selbsttest Strichcode-Leser gescheitert: ' + (e && e.message), 'fehler');
      }
    }

    // Handscanner: tippt und schickt Enter.
    el.feld.addEventListener('keydown', function (ev) {
      if (ev.key === 'Enter') {
        ev.preventDefault();
        var v = el.feld.value;
        el.feld.value = '';
        if (v.trim()) { scan(v, false); }
      }
    });
    el.kamera.addEventListener('click', kameraStarten);
    var tonKnopf = $('sc-ton');
    if (tonKnopf) {
      tonKnopfZeichnen();
      tonKnopf.addEventListener('click', function () {
        try { localStorage.setItem(TON_KEY, tonAn() ? 'aus' : 'an'); } catch (e) { /* egal */ }
        tonKnopfZeichnen();
        if (tonAn()) { tonBereit(); tonSpielen(true); }   // Probe-Tick beim Einschalten
      });
    }
    el.warenkorb.addEventListener('click', function () { allesInDenWarenkorb(); });
    if (el.sofort) { el.sofort.addEventListener('click', sofortKaufen); }
    if (el.favorit) { el.favorit.addEventListener('click', favoritenOeffnen); }
    if (el.vergleich) { el.vergleich.addEventListener('click', vergleichen); }
    if (el.favSpeichern) {
      el.favSpeichern.addEventListener('click', favoritenSpeichern);
      el.favName.addEventListener('keydown', function (ev) {
        if (ev.key === 'Enter') { ev.preventDefault(); favoritenSpeichern(); }
        if (ev.key === 'Escape') { hide(el.favForm); }
      });
      $('sc-fav-abbrechen').addEventListener('click', function () { hide(el.favForm); });
      if ($('sc-fav-zu')) { $('sc-fav-zu').addEventListener('click', function () { hide(el.favForm); }); }
      if (el.favListe) { el.favListe.addEventListener('change', favNameZeigen); }
    }
    el.leeren.addEventListener('click', function () {
      if (window.confirm('Liste leeren?')) { liste = []; speichern(); zeichnen(); hide(el.meldung); }
    });

    // Kam der Aufruf ueber den QR-Link? Dann einmal verarbeiten und den Parameter
    // entfernen — sonst legt ein Neuladen den Artikel ein zweites Mal hinein.
    var p = new URLSearchParams(window.location.search);
    var s = p.get('s');
    if (s) {
      p.delete('s');
      var qs = p.toString();
      window.history.replaceState({}, '', window.location.pathname + (qs ? '?' + qs : '') + window.location.hash);
      // ⚠️ Erst nach den Mengen — sonst bekaeme der erste Scan immer 1 VPE.
      mengenDa.then(function () { scan(s, true); });
    }

    // Cursor ins Feld — der Handscanner tippt sofort los. ⚠️ Nur, wenn die Seite allein im
    // Fenster steht: eingebettet (Abnahme, Schritt 4) zog der Fokus die ganze Seite nach unten.
    if (window.self === window.top) { el.feld.focus(); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
